/**
 * Created by Bryan C 3/31/2026
 */

angular.module('mediacloudApp')
        .directive('ssPlayerVjs', ['AssetService', 'AVMedia', 'BlobMedia', 'ZipMedia', 'mediaDropOff', 'mediaPauseAndDropOff', 'CollectionService', '$http', '$timeout', function (AssetService, AVMedia, BlobMedia, ZipMedia, mediaDropOff, mediaPauseAndDropOff, CollectionService, $http, $timeout) {

                return {
                    restrict: 'E',
                    replace: true,
                    $scope: {
                        asset: '=',
                        captionsupdated: '='
                    },
                    templateUrl: 'scripts/components/player/ssplayer.html',
                    link: function ($scope, element, attrs) {

                        var player;
                        var testVideo = false;
                        var testHlsUrl = "";
                        $http({method: 'GET', url: 'api/properties?name=TEST_VIDEO_HLS_URL'})
                                .then(function (response) {
                                    if (response.data.value !== null && response.data.value.length > 0) {
                                        testVideo = true;
                                        testHlsUrl = response.data.value;
                                        console.log("-------------Using Test Video-------------\ntestHlsUrl: " + testHlsUrl);
                                    }
                                });
                        var AUTHTOKEN = $scope.$root.AUTHTOKEN;
                        var sessionId;
                        if (typeof window.crypto.randomUUID === 'function') {
                            sessionId = crypto.randomUUID();
                        } else {
                            sessionId = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                              (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
                            );
                        }
                        var lastCall = 0;

                        mediaDropOff.videoPlayed = false;
                        mediaDropOff.hasFinished = false;
                        mediaPauseAndDropOff.isPlayed = false;
                        mediaPauseAndDropOff.isPaused = false;
                        $scope.srcLang = "English";
                        $scope.captionsIncluded = false;
                        $scope.subtitlesIncluded = false;
                        $scope.audioDescriptionsIncluded = false;
                        $scope.audioTextDescriptionsIncluded = false;
                        $scope.currentTextTrack = "";
                        $scope.currentAudioTrack = "";
                        $scope.currentAudioDescription = "";
                        $scope.currentAudioDescriptionType = "";

                        $scope.updateTimeout = null;

                        //adopted from http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
                        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                            return v.toString(16);
                        });

                        if (!document.cookie.match(/^(.*;)?\s*ss_identifier=[^;]+(.*)?$/)) {
                            document.cookie = 'ss_identifier=' + uuid + '; expires=Tue, 19 Jan 2038 03:14:07 UTC; path=/';
                        }

                        /**
                         * This method parses subtitles and truncates them for clips
                         *
                         * @param txt
                         * @returns {Array}
                         */
                        var parseSubtitles = function (txt) {
                            var self = this;
                            var TIMECODE_RE = /^(([0-9]{2}:){1,2}[0-9]{2}[,.][0-9]{3}) --\> (([0-9]{2}:){1,2}[0-9]{2}[,.][0-9]{3})(.*)/;

                            function seconds(timecode) {
                                var els = timecode.split(':');
                                if (els.length == 2) {
                                    els.unshift(0);
                                }
                                return els[0] * 60 * 60 + els[1] * 60 + parseFloat(els[2].replace(',', '.'));
                            }

                            var entries = [];
                            var start, end;
                            for (var i = 0, lines = txt.split("\n"), len = lines.length, entry = {}, title, timecode, text; i < len; i++) {
                                timecode = TIMECODE_RE.exec(lines[i]);

                                if (timecode) {

                                    // title
                                    title = lines[i - 1];

                                    // text
                                    text = "<p>" + lines[++i] + "</p><br/>";
                                    while (typeof lines[++i] === 'string' && lines[i].trim() && i < lines.length) {
                                        text += "<p>" + lines[i] + "</p><br/>";
                                    }

                                    start = seconds(timecode[1]);
                                    end = seconds(timecode[3]);

                                    // These properties are set at the player level in FlowPlayer when playing ShareStream clips
                                    if (self.start && self.end) {
                                        // Discard subtitles which are outside the bounds of the clip
                                        if (self.start > end || start > self.end) {
                                            continue;
                                        }
                                        // Subtract the offset (self.start) from the start and end times of the subtitle, so they match the clip
                                        start -= self.start;
                                        if (start < 0) {
                                            start = 0;
                                        }
                                        end -= self.start;
                                    }

                                    // entry
                                    entry = {
                                        title: title,
                                        startTime: start,
                                        endTime: end,
                                        text: text
                                    };
                                    entries.push(entry);
                                }
                            }
                            return entries;
                        };

                        var getAVMedia = function (clip) {
                            var aid = $scope.asset.aid;

                            if (clip && clip.originAid) {
                                aid = clip.originAid;
                            }

                            AVMedia.get({
                                cid: $scope.asset.cid,
                                aid: aid
                            }, function (media) {
                                $scope.media = media;
                                if (!testVideo) {
                                    $scope.hlsUrl = media.mediaUrl + "/playlist.m3u8?authToken=" + (AUTHTOKEN ? AUTHTOKEN : JSON.parse(localStorage.getItem("ls.authToken")));
                                } else {
                                    $scope.hlsUrl = testHlsUrl;
                                }

                                if ($scope.asset.type === 'Audio') {
                                    var showCoverArt = false;
                                    var url = "./api/feature-flags"
                                    //TODO: Refactor to retrieve feature flags on startup.
                                    $.ajax({
                                        url: url,
                                        async: false,
                                        type: 'GET',
                                        success: function (data) {
                                            $scope.showCoverArt = data.showCoverArt;
                                        }
                                    });

                                    if ($scope.showCoverArt === "true") {
                                        ssClip.coverImage = $scope.asset.thumbnailUrl;
                                    }
                                }
                                $scope.initializeVideo(
                                        "asset-video",
                                        800,
                                        400,
                                        media,
                                        clip
                                        );
                                var api;
                                var player = $('.fp-ui')[0];

                                var lastTabTime = (new Date).getTime(),
                                        lastFocusTime;

                                $scope.enableStats = true;
                                $scope.triggerUnload = true;
                                //service used to keep track of video start/end - used for drop off rate
                                //moving this from 'resume' to 'ready' so it also works for iPhones
                                mediaDropOff.playMedia(true, false, $scope.asset.cid, $scope.asset.aid);

                                //set isViewed flag to 1; don't update for channel asset playback
                                CollectionService.GetCollection.get({cid: $scope.asset.cid, type: ''}, function (coll) {

                                    $scope.collectionType = coll.type;
                                    if ($scope.collectionType !== 'channel') {
                                        var markAsViewed = [];
                                        markAsViewed.push({collectionId: $scope.asset.cid, assetId: $scope.asset.aid, isViewed: "1"});
                                        AssetService.UpdateMetadata.update(markAsViewed);
                                    }
                                });

                                // Disables controls while playing copyright notice
                                if ($scope.asset.copyrightNoticeRequired) {
                                    if (api.video.index === 1) {
                                        api.disable(false);
                                        $scope.enableStats = true;
                                    } else if (api.video.index === 0) {
                                        api.disable(true);
                                        $scope.enableStats = false;
                                    }
                                }
                            })
                            /*.on('cuepoint', function(e, api, cuepoint) {
                             let divAudioOnlyCaptions = document.getElementById('divAudioOnlyCaptions')
                             if (cuepoint.subtitle && $scope.showCoverArt === 'false') {
                             divAudioOnlyCaptions.innerHTML = cuepoint.subtitle.text;
                             }
                             }).on('pause', function () {

                             var mediaDuration = api.video.duration;
                             var secondsPlayedWhenPaused = api.video.time;

                             if ($scope.enableStats) {
                             if (mediaDropOff.playingDone) {
                             // This is executed when the user starts playing the video and moves out of the playback page
                             //                                    var recordPlayback = new AssetService.RecordPlayback({
                             //                                        cid: mediaDropOff.collectionId,
                             //                                        aid: mediaDropOff.assetId,
                             //                                        type: 'S',
                             //                                        secondsPlayed: secondsPlayedWhenPaused,
                             //                                        mediaDuration: mediaDuration
                             //                                    });
                             //                                    recordPlayback.$save();
                             $scope.flowplayer.shutdown();
                             } else {
                             // This is executed whenever the user pauses the video or when the playback finishes
                             mediaPauseAndDropOff.pauseDropOff(true, mediaDropOff.collectionId, mediaDropOff.assetId, secondsPlayedWhenPaused, mediaDuration);
                             }
                             }
                             }).on('finish', function () {
                             element.css({backgroundImage: 'none'});

                             if($scope.enableStats){
                             var secondsPlayed = api.video.time;
                             var mediaDuration = api.video.duration;

                             // This is executed when playback finishes
                             var recordPlayback = new AssetService.RecordPlayback({
                             cid: mediaDropOff.collectionId,
                             aid: mediaDropOff.assetId,
                             type: 'S',
                             sessionId: sessionId,
                             secondsPlayed: secondsPlayed,
                             mediaDuration: mediaDuration
                             });
                             recordPlayback.$save();
                             mediaDropOff.hasFinished = true;
                             $scope.triggerUnload = false;
                             }
                             }).on('unload', function () {
                             element.css({backgroundImage: 'none'});
                             if($scope.enableStats && $scope.triggerUnload){
                             var secondsPlayed = api.video.time;
                             var mediaDuration = api.video.duration;
                             // This is executed when playback finishes
                             var recordPlayback = new AssetService.RecordPlayback({
                             cid: mediaDropOff.collectionId,
                             aid: mediaDropOff.assetId,
                             type: 'S',
                             sessionId: sessionId,
                             secondsPlayed: secondsPlayed,
                             mediaDuration: mediaDuration
                             });
                             recordPlayback.$save();
                             mediaDropOff.hasFinished = true;
                             }
                             }).on('fullscreen', function () {
                             parent.postMessage({
                             event_id: 'fs_quip_message',
                             data: {
                             origin: $scope.flowplayer.conf.origin
                             }
                             },
                             "*");
                             })*/
                        };

                        /*window.addEventListener('beforeunload', function(event) {
                         // This is executed when playback finishes
                         if ($scope.flowplayer.playing) {
                         var recordPlayback = new AssetService.RecordPlayback({
                         cid: $scope.asset.cid,
                         aid: $scope.asset.aid,
                         type: 'S',
                         sessionId: sessionId,
                         secondsPlayed: $scope.flowplayer.video.time,
                         mediaDuration:  $scope.flowplayer.video.duration
                         });
                         recordPlayback.$save();
                         mediaDropOff.hasFinished = true;
                         }
                         }, false);

                         window.addEventListener('message', (event) => {
                         if (event.data.event_id === 'fs_quip_message_ack') {
                         $scope.flowplayer.pause();
                         }
                         });*/

                        /**
                         * Parse a timestamp as number of seconds.
                         *
                         * @param timeStamp
                         * @returns {number}
                         * @private
                         */
                        var timeInSeconds = function (timeStamp) {
                            var timeData = /^([0-9]{2}):([0-9]{2}):([0-9]{2})$/.exec(timeStamp),
                                    h = parseInt(timeData[1]),
                                    m = parseInt(timeData[2]),
                                    s = parseInt(timeData[3]);
                            return (h * 3600) + (m * 60) + s;
                        };

                        var loadAssetMedia = function () {
                            if (!$scope.asset.drmMessage) {

                                if ($scope.asset.type === 'Video' || $scope.asset.type === 'Audio' || $scope.asset.type === 'Clip') {

                                    element.addClass("play-button");

                                    if ($scope.asset.type === 'Clip') {
                                        AssetService.GetClipInfo.get({
                                            cid: $scope.asset.cid,
                                            aid: $scope.asset.aid
                                        }, function (clip) {
                                            getAVMedia(clip);
                                        });
                                    } else if ($scope.asset.type === 'Quiz') {
                                        AssetService.GetQuizInfo.get({
                                            cid: $scope.asset.cid,
                                            aid: $scope.asset.aid
                                        }, function (quiz) {
                                            getAVMedia(quiz);
                                        });
                                    } else if ($scope.asset.isStreamable) {
                                        getAVMedia();
                                    } else if ($scope.asset.isDownloadable) {
                                        // Just show the thumbnail for downloadable assets
                                        element.css({
                                            backgroundImage: 'url(' + $scope.asset.thumbnailUrl + ')',
                                            backgroundSize: 'cover',
                                            backgroundRepeat: 'no-repeat',
                                            width: '100%',
                                            height: '100%'
                                        });
                                    }

                                } else {

                                    element.addClass('non-av-player');
                                    $('<input />', {
                                        type: 'button',
                                        value: 'Go Fullscreen',
                                        id: 'fsbutton'
                                    }).prependTo(element.parent());

                                    if ($scope.asset.type === 'Images') {

                                        BlobMedia.getMedia({
                                            aid: $scope.asset.aid,
                                            cid: $scope.asset.cid,
                                            type: 'image'
                                        }, function (result) {
                                            var mediaFile = result.mediaFile;
                                            if (mediaFile) {
                                                var imgUrl = URL.createObjectURL(mediaFile);
                                                $('<img />', {
                                                    src: imgUrl,
                                                    id: 'imgContainer'
                                                }).css({
                                                    width: '100%'
                                                }).appendTo(element);
                                                enableFS('imgContainer');
                                                var recordPlayback = new AssetService.RecordPlayback({
                                                    cid: $scope.asset.cid,
                                                    aid: $scope.asset.aid,
                                                    type: 'S',
                                                    secondsPlayed: null,
                                                    mediaDuration: null
                                                });
                                                recordPlayback.$save();
                                            }
                                        });
                                    } else {
                                        // TODO: Add a check to see if flash is supported - so a message can be shown on mobile devices ($.flash.available doesn't work on CCC BB)
                                        element.css({backgroundImage: 'url(' + $scope.asset.thumbnailUrl + ')'});

                                        $('<div class="play-btn"/>').appendTo(element);

                                        element.bind('click', function () {
                                            element.find('.play-btn').hide();
                                            if ($scope.asset.type == 'zippedMedia') {
                                                ZipMedia.getMedia({
                                                    aid: $scope.asset.aid,
                                                    cid: $scope.asset.cid,
                                                    type: 'zippedMedia'
                                                }, function (result) {
                                                    if (result.mediaUrl) {
                                                        $('<iframe />', {
                                                            src: result.mediaUrl,
                                                            id: 'zippedMediaFrame'
                                                        }).css({
                                                            border: 'none'
                                                        }).appendTo(element);
                                                        enableFS('zippedMediaFrame');
                                                        var recordPlayback = new AssetService.RecordPlayback({
                                                            cid: $scope.asset.cid,
                                                            aid: $scope.asset.aid,
                                                            type: 'S',
                                                            secondsPlayed: null,
                                                            mediaDuration: null
                                                        });
                                                        recordPlayback.$save();
                                                    }
                                                });

                                            } else if ($scope.asset.type === 'Swf') {

                                                BlobMedia.getMedia({
                                                    aid: $scope.asset.aid,
                                                    cid: $scope.asset.cid,
                                                    type: 'swf'
                                                }, function (result) {
                                                    var mediaFile = result.mediaFile;
                                                    if (mediaFile) {
                                                        var swfUrl = URL.createObjectURL(mediaFile);
                                                        var flashElement = $('<object>', {
                                                            id: 'swfContainer',
                                                            type: 'application/x-shockwave-flash',
                                                            data: swfUrl
                                                        });

                                                        $('<param />', {
                                                            name: 'movie',
                                                            value: swfUrl
                                                        }).appendTo(flashElement);

                                                        $('<param />', {
                                                            name: 'allowfullscreen',
                                                            value: true
                                                        }).appendTo(flashElement);

                                                        flashElement.css({
                                                            width: '100%',
                                                            height: '100%',
                                                            border: 'none'
                                                        }).appendTo(element);
                                                        enableFS('swfContainer');
                                                        var recordPlayback = new AssetService.RecordPlayback({
                                                            cid: $scope.asset.cid,
                                                            aid: $scope.asset.aid,
                                                            type: 'S',
                                                            secondsPlayed: null,
                                                            mediaDuration: null
                                                        });
                                                        recordPlayback.$save();
                                                    }
                                                });
                                            }

                                        });
                                    }
                                }
                            } else {
                                element.addClass('non-av-player');
                                var drmTemplate = "<i class='fa fa-5x fa-ban'></i><p>" + $scope.asset.drmMessage + "</p>";
                                element.append($(drmTemplate));
                            }
                        };

                        var enableFS = function (containerId) {
                            var fullScreenApi = {
                                supportsFullScreen: false,
                                requestFullScreen: function () {},
                                prefix: '',
                                isEdge: false
                            },
                                    browserPrefixes = 'webkit moz o khtml'.split(' ');

                            if (typeof document.cancelFullScreen != 'undefined') {
                                fullScreenApi.supportsFullScreen = true;
                            } else if (typeof document.exitFullscreen != 'undefined') {
                                fullScreenApi.supportsFullScreen = true;
                                fullScreenApi.isEdge = true;
                            } else if (typeof document.msExitFullscreen != 'undefined') {
                                fullScreenApi.supportsFullScreen = true;
                                fullScreenApi.prefix = 'ms';
                            } else {
                                for (var i = 0, il = browserPrefixes.length; i < il; i++) {
                                    fullScreenApi.prefix = browserPrefixes[i];

                                    if (typeof document[fullScreenApi.prefix + 'CancelFullScreen'] != 'undefined') {
                                        fullScreenApi.supportsFullScreen = true;
                                        break;
                                    }
                                }
                            }

                            if (fullScreenApi.supportsFullScreen) {
                                fullScreenApi.requestFullScreen = function (el) {
                                    return this.prefix === '' ? (this.isEdge ? el.requestFullscreen() : el.requestFullScreen()) : (this.prefix === 'ms' ? el['msRequestFullscreen']() : el[this.prefix + 'RequestFullScreen']());
                                };
                            }

                            // jQuery plugin
                            if (typeof jQuery != 'undefined') {
                                jQuery.fn.requestFullScreen = function () {

                                    return this.each(function () {
                                        var el = jQuery(this);
                                        if (fullScreenApi.supportsFullScreen) {
                                            fullScreenApi.requestFullScreen(el);
                                        }
                                    });
                                };
                            }

                            window.fullScreenApi = fullScreenApi;

                            var fsbtn = document.getElementById('fsbutton'),
                                    fsElement = document.getElementById(containerId);

                            fsbtn.addEventListener('click', function () {
                                window.fullScreenApi.requestFullScreen(fsElement);
                            }, true);
                        };

                        $scope.$on('$stateChangeStart', function (event) {

                            if (mediaDropOff.videoPlayed === true) {
                                mediaDropOff.playMedia(false, true, mediaDropOff.collectionId, mediaDropOff.assetId);
                                if (mediaPauseAndDropOff.isPlayed === true && mediaPauseAndDropOff.isPaused === true && !mediaDropOff.hasFinished) {
                                    mediaDropOff.playingDone = false;
                                }
                            }
                            if ($scope.enableStats) {
                                // This is executed when the user pauses a video and then moves out of the page
                                if (mediaPauseAndDropOff.isPlayed === true && mediaPauseAndDropOff.isPaused === true && !mediaDropOff.hasFinished) {
                                    var recordPlayback = new AssetService.RecordPlayback({
                                        cid: mediaPauseAndDropOff.collectionId,
                                        aid: mediaPauseAndDropOff.assetId,
                                        type: 'S',
                                        sessionId: sessionId,
                                        secondsPlayed: mediaPauseAndDropOff.secondsPlayed,
                                        mediaDuration: mediaPauseAndDropOff.mediaDuration
                                    });
                                    recordPlayback.$save();
                                }
                            }

                            /*if($scope.flowplayer){
                             if(!$scope.flowplayer.playing){
                             $scope.flowplayer.shutdown();
                             }
                             }*/
                        });

                        $scope.$watch('asset', function () {
                            if ($scope.asset) {
                                loadAssetMedia();
                            }
                        })

                        $scope.initializeVideo = function (playerId, width, height, media, clip) {
                            console.log("initializeVideo(" + playerId + ")");
                            if (playerId) {
                                //Dispose of any player with the same Id
                                var allPlayers = videojs.getPlayers();
                                for (var tempPlayerId in allPlayers) {
                                    var playerTemp = allPlayers[tempPlayerId];
                                    if (playerTemp && playerId === tempPlayerId) {
                                        playerTemp.dispose();
                                    }
                                }
                                var videoOptions = {
                                    crossOrigin: 'anonymous',
                                    controls: true,
                                    autoplay: false,
                                    fluid: true,
                                    aspectRatio: '16:9',
                                    preload: "auto",
                                    playbackRates: [2, 1.5, 1, 0.5, 0.25],
                                    inactivityTimeout: 5000,
                                    width: "auto",
                                    noUITitleAttributes: true,
                                    controlBar: {
                                        skipButtons: {
                                            forward: 10,
                                            backward: 10
                                        }
                                    },
                                    poster: $scope.asset.thumbnailUrl,
                                    textTrackSettings: false,
                                    playsinline: true,
                                    html5: {
                                        nativeTextTracks: false
                                    }
                                };
                                //for iOS use nativeTextTracks and nativeTextTracks styling
                                if (videojs.browser.IS_IOS) {
                                    videoOptions.html5.nativeTextTracks = true;
                                    $(".video-js-custom.video-js").addClass("vjs-is-ios");
                                }
                                //initialize player
                                if (!testVideo) {
                                    // Global request callback defining beforeSend function, will affect every player.
                                    var globalXhrRequestHook = (options) => {
                                        options.beforeSend = (xhr) => {
                                            xhr.setRequestHeader('x-auth-token', AUTHTOKEN ? AUTHTOKEN : JSON.parse(localStorage.getItem("ls.authToken")));
                                        };
                                        return options;
                                    };
                                    videojs.Vhs.xhr.onRequest(globalXhrRequestHook);
                                }
                                player = videojs(playerId, videoOptions);

                                player.src({
                                    type: "application/x-mpegURL",
                                    src: $scope.hlsUrl
                                });

                                if (!testVideo && clip && clip.startTime && clip.endTime) {
                                    var clipStart = timeInSeconds(clip.startTime);
                                    var clipEnd = timeInSeconds(clip.endTime);
                                    player.offset({
                                        start: clipStart,
                                        end: clipEnd,
                                    });
                                }

                                let started = false;

                                player.on('play', function () {
                                    if (!started) {
                                        started = true;
                                        var mediaDuration = player.duration();
                                        var recordPlayback = new AssetService.RecordPlayback({
                                            cid: $scope.asset.cid,
                                            aid: $scope.asset.aid,
                                            type: 'S',
                                            sessionId: sessionId,
                                            secondsPlayed: 0,
                                            mediaDuration: mediaDuration
                                        });
                                        recordPlayback.$save();
                                    }
                                });

                                player.on('timeupdate', () => {
                                    var currentTime = player.currentTime();

                                    if (currentTime - lastCall >= 5) {
                                        lastCall = currentTime;
                                        var mediaDuration = player.duration();
                                        var recordPlayback = new AssetService.RecordPlayback({
                                            cid: $scope.asset.cid,
                                            aid: $scope.asset.aid,
                                            type: 'S',
                                            sessionId: sessionId,
                                            secondsPlayed: currentTime,
                                            mediaDuration: mediaDuration
                                        });
                                        recordPlayback.$save();
                                    }
                                });

                                //insert markers
                                player.on("loadedmetadata", function () {
                                    $scope.metadataloaded = true;
                                    $scope.updateAudioTrackIcon();
                                    player.trigger('playerresize');
                                });

                                player.on("ratechange", function () {
                                    var rate = player
                                            .playbackRate()
                                            .toString()
                                            .replace(".", "_");
                                    //console.log("rate: "+rate);
                                    $(
                                            ".video-js-custom.video-js .vjs-playback-rate button"
                                            )
                                            .removeClass(
                                                    "vjs-rate-2 vjs-rate-1_5 vjs-rate-1 vjs-rate-0_5 vjs-rate-0_25"
                                                    )
                                            .addClass("vjs-rate-" + rate);
                                    $(".video-js-custom.video-js .vjs-menu-speed").removeClass(
                                            "vjs-rate-2 vjs-rate-1_5 vjs-rate-1 vjs-rate-0_5 vjs-rate-0_25"
                                    ).addClass("vjs-rate-" + rate);
                                    $(".video-js-custom.video-js .vjs-menu-speed .vjs-menu-value").text(player.playbackRate().toString()+"x");
                                });

                                player.audioTracks().addEventListener('addtrack', function (event) {
                                    $timeout(function () {
                                        $scope.updateAudioTrackIcon();
                                    }, 0);
                                });

                                player.audioTracks().on("change", function (event) {
                                    $scope.updateAudioTrackIcon();
                                });

                                player.on('durationchange', function () {
                                    if (player.duration() > 0) {
                                        $(".video-js-custom.video-js").addClass("vjs-times-loaded");
                                    }
                                });

                                /// Attach the Copyright Notice clip if required
                                if (!testVideo && $scope.asset.copyrightNoticeRequired) {
                                    player.ads();

                                    var copyrightPrerollSource = {
                                        src: media.copyrightNoticeUrl + "/playlist.m3u8?authToken=" + (AUTHTOKEN ? AUTHTOKEN : JSON.parse(localStorage.getItem("ls.authToken"))),
                                        type: 'application/x-mpegURL'
                                    };

                                    player.on('readyforpreroll', function () {
                                        player.ads.startLinearAdMode();

                                        player.src(copyrightPrerollSource);

                                        player.one('adplaying', function () {
                                            player.trigger('ads-ad-started');
                                        });

                                        player.one('adended', function () {
                                            player.ads.endLinearAdMode();
                                        });

                                        player.on('error', function () {
                                            console.error('Preroll error, resuming content.');
                                            player.ads.endLinearAdMode();
                                        });
                                    });

                                    player.trigger('adsready');

                                }

                                player.on('ended', function() {
                                    element.css({backgroundImage: 'none'});

                                    if($scope.enableStats){
                                        // This is executed when playback finishes
                                        var recordPlayback = new AssetService.RecordPlayback({
                                            cid: mediaDropOff.collectionId,
                                            aid: mediaDropOff.assetId,
                                            type: 'S',
                                            sessionId: sessionId,
                                            secondsPlayed: player.currentTime(),
                                            mediaDuration: player.duration()
                                        });
                                        recordPlayback.$save();
                                        mediaDropOff.hasFinished = true;
                                        $scope.triggerUnload = false;
                                    }
                                });

                                player.on('pause', function() {
                                    var mediaDuration = player.duration();
                                    var secondsPlayedWhenPaused = player.currentTime();

                                    if ($scope.enableStats) {
                                        if (mediaDropOff.playingDone) {
                                            // This is executed when the user starts playing the video and moves out of the playback page
        //                                    var recordPlayback = new AssetService.RecordPlayback({
        //                                        cid: mediaDropOff.collectionId,
        //                                        aid: mediaDropOff.assetId,
        //                                        type: 'S',
        //                                        sessionId: sessionId,
        //                                        secondsPlayed: secondsPlayedWhenPaused,
        //                                        mediaDuration: mediaDuration
        //                                    });
        //                                    recordPlayback.$save();
                                        } else {
                                            // This is executed whenever the user pauses the video or when the playback finishes
                                            mediaPauseAndDropOff.pauseDropOff(true, mediaDropOff.collectionId, mediaDropOff.assetId, secondsPlayedWhenPaused, mediaDuration);
                                        }
                                    }
                                });

                                player.ready(function () {
                                    console.log("Player is Ready!");

                                    //Disable Picture in Picture
                                    $(".video-js-custom.video-js video").attr(
                                            "disablepictureinpicture",
                                            ""
                                            );

                                    // initialize captions
                                    $.each(JSON.parse($scope.media.captions), function (i, k) {
                                        var trackKind = "";
                                        if (k.title.includes("(Audio Description)")) {
                                            k.title = k.title.replace("(Audio Description)", "[AD]");
                                            trackKind = 'descriptions';
                                            $scope.audioTextDescriptionsIncluded = true;
                                        } else if (k.language === $scope.srcLang) {
                                            k.title += " [CC]";
                                            trackKind = 'captions';
                                            $scope.captionsIncluded = true;
                                        } else if (k.language !== $scope.srcLang) {
                                            trackKind = 'subtitles';
                                            $scope.subtitlesIncluded = true;
                                        }
                                        var langCode = $scope.getLangCode(k.language);
                                        k.captionUrl = $scope.media.captionUrl + '&id=' + k.id;
                                        if (k.fileName && k.fileName.includes(".srt")) {
                                            // convert srt to vtt
                                            $.ajax({
                                                url: k.captionUrl,
                                                type: 'GET',
                                                dataType: 'text',
                                                async: false,
                                                success: function (data) {
                                                    const vttText = $scope.convertSRTtoVTT(data);
                                                    const vttBlob = new Blob([vttText], {type: 'text/vtt'});
                                                    const vttUrl = URL.createObjectURL(vttBlob);

                                                    player.addRemoteTextTrack({
                                                        kind: trackKind,
                                                        src: vttUrl,
                                                        srclang: langCode,
                                                        label: k.title,
                                                        mode: 'disabled'
                                                    }, false);
                                                },
                                                error: function (xhr, status, error) {
                                                    console.error('Failed to load subtitles:', error);
                                                }
                                            });
                                        } else {
                                            // add vtt directly
                                            player.addRemoteTextTrack({
                                                kind: trackKind,
                                                src: k.captionUrl,
                                                srclang: langCode,
                                                label: k.title,
                                                mode: 'disabled'
                                            }, false);
                                        }
                                    });
                                    //console.log("captionsIncluded: " + $scope.captionsIncluded);
                                    //console.log("subtitlesIncluded: " + $scope.subtitlesIncluded);
                                    //console.log("audioTextDescriptionsIncluded: " + $scope.audioTextDescriptionsIncluded);
                                    if($scope.captionsIncluded || $scope.subtitlesIncluded){
                                        $(".video-js-custom.video-js:not(.vjs-has-subs-caps)").addClass("vjs-has-subs-caps");
                                    }else{
                                        $(".video-js-custom.video-js.vjs-has-subs-caps").removeClass("vjs-has-subs-caps");
                                    }
                                    if($scope.audioTextDescriptionsIncluded){
                                        $(".video-js-custom.video-js:not(.vjs-has-text-audio-descriptions)").addClass("vjs-has-text-audio-descriptions");
                                    }else{
                                        $(".video-js-custom.video-js.vjs-has-text-audio-descriptions").removeClass("vjs-has-text-audio-descriptions");
                                    }

                                    //Text track listener
                                    var textTrackList = player.textTracks();

                                    textTrackList.addEventListener('change', function() {
                                        //console.log("textTrackList change!");
                                        var isShowingCC = false;
                                        var hasAD = false;
                                        var hasCC = false;
                                        var isShowingAD = false;
                                        for (var i = 0; i < textTrackList.length; i++) {
                                            var track = textTrackList[i];
                                            //console.log("track.label: "+track.label + " " + track.kind + " "+ track.mode);
                                            if(track.label.includes("[AD]")){
                                                hasAD = true;
                                            } else if(track.kind !== "metadata"){
                                                hasCC = true;
                                            }
                                            if (track.mode === 'showing') {
                                                if(track.label.includes("[AD]")){
                                                    isShowingAD = true;
                                                    $(".video-js-custom.video-js .vjs-menu-ad .vjs-menu-value").text(track.label);
                                                    if(!$(".video-js-custom.video-js").hasClass("vjs-showing-audio-descriptions")){
                                                        $scope.currentAudioDescription = track.label;
                                                        $scope.currentAudioDescriptionType = "text";
                                                    }
                                                }else{
                                                    isShowingCC = true;
                                                    $(".video-js-custom.video-js .vjs-menu-cc .vjs-menu-value").text(track.label);
                                                    $scope.currentTextTrack = track.label;
                                                }
                                            }
                                        }
                                        if(isShowingAD && isShowingCC){
                                            for (var i = 0; i < textTrackList.length; i++) {
                                                var track = textTrackList[i];
                                                if(track.label.includes("[AD]")){
                                                    textTrackList[i].mode = "disabled";
                                                }
                                                isShowingAD = false;
                                            }
                                        }
                                        //console.log("isShowingAD: "+isShowingAD+" isShowingCC: "+isShowingCC);
                                        if(isShowingCC){
                                            $(".video-js-custom.video-js").addClass("vjs-showing-subs-caps");
                                            $(".video-js-custom.video-js .vjs-subs-caps-button-toggle").attr("aria-pressed","true");
                                            $(".video-js-custom.video-js .vjs-settings-dialog .vjs-menu-ad .vjs-menu-wrapper").prop("disabled",true);
                                        }else{
                                            $(".video-js-custom.video-js").removeClass("vjs-showing-subs-caps");
                                            $(".video-js-custom.video-js .vjs-menu-cc .vjs-menu-value").text("Off");
                                            $(".video-js-custom.video-js .vjs-subs-caps-button-toggle").attr("aria-pressed","false");
                                            $(".video-js-custom.video-js .vjs-settings-dialog .vjs-menu-ad .vjs-menu-wrapper").prop("disabled",false);
                                        }
                                        //console.log("hasAD: "+hasAD);
                                        if(hasAD){
                                            $(".video-js-custom.video-js:not(.vjs-has-text-audio-descriptions)").addClass("vjs-has-text-audio-descriptions");
                                        }else{
                                            $(".video-js-custom.video-js.vjs-has-text-audio-descriptions").removeClass("vjs-has-text-audio-descriptions");
                                        }
                                        //console.log("hasCC: "+hasCC);
                                        if(hasCC){
                                            $(".video-js-custom.video-js:not(.vjs-has-subs-caps)").addClass("vjs-has-subs-caps");
                                        }else{
                                            $(".video-js-custom.video-js.vjs-has-subs-caps").removeClass("vjs-has-subs-caps");
                                        }
                                        if(isShowingAD){
                                            $(".video-js-custom.video-js").addClass("vjs-showing-text-audio-descriptions");
                                        }else{
                                            $(".video-js-custom.video-js").removeClass("vjs-showing-text-audio-descriptions");
                                            $(".video-js-custom.video-js .vjs-menu-ad .vjs-menu-value").text("Off");
                                        }

                                        $scope.setAudioDescriptionPressed();
                                    });

                                    //Add Progress Mask and Bar
                                    $('.video-js-custom.video-js .vjs-progress-control.vjs-control').append('<div class="vjs-progress-mask"><div class="vjs-play-progress-bar"></div></div>');

                                    //Add Progress Elypse
                                    $('.video-js-custom.video-js .vjs-play-progress.vjs-slider-bar').append('<div class="vjs-progress-point"></div>');

                                    //Add mute tooltip and polygon
                                    $('.video-js-custom.video-js .vjs-mute-control').append('<div class="vjs-tooltip" aria-hidden="true"></div><div class="vjs-polygon" aria-hidden="true" ></div>');
                                    $(".video-js-custom.video-js .vjs-mute-control")
                                            .on("mouseenter", function (event) {
                                                $scope.showTooltip(event);
                                            })
                                            .on("mouseleave", function (event) {
                                                $scope.hideTooltip(event);
                                            })
                                            .on("focus", function (event) {
                                                $scope.showTooltip(event);
                                            })
                                            .on("blur", function (event) {
                                                $scope.hideTooltip(event);
                                            })
                                            .keydown(function (event) {
                                                if (27 === event.which) {
                                                    $(".vjs-button").removeClass("vjs-tooltip-show");
                                                }
                                            });

                                    //Add volume bar background
                                    $(".video-js-custom.video-js .vjs-volume-control").prepend('<div class="vjs-vol-bar-start"></div>');
                                    $(".video-js-custom.video-js .vjs-volume-control").append('<div class="vjs-vol-bar-end"></div>');

                                    //Add volume control tooltip and polygon
                                    $('.video-js-custom.video-js .vjs-volume-control').append('<div class="vjs-tooltip" aria-hidden="true">Volume</div><div class="vjs-polygon" aria-hidden="true" ></div>');
                                    $(".video-js-custom.video-js .vjs-volume-control")
                                            .on("mouseenter", function (event) {
                                                $scope.showTooltip(event);
                                            }).on("mouseleave", function (event) {
                                        $scope.hideTooltip(event);
                                    }).keydown(function (event) {
                                        if (27 === event.which) {
                                            $(".vjs-button").removeClass("vjs-tooltip-show");
                                        }
                                    });

                                    $(".video-js-custom.video-js .vjs-volume-control .vjs-volume-bar")
                                            .on("focus", function (event) {
                                                $scope.showTooltip(event);
                                            }).on("blur", function (event) {
                                        $scope.hideTooltip(event);
                                    });

                                    //Add play control polygon
                                    $(
                                            '.video-js-custom.video-js .vjs-play-control'
                                            ).append(
                                            '<div class="vjs-tooltip" aria-hidden="true"></div><div class="vjs-polygon" aria-hidden="true" ></div>'
                                            );
                                    $(".video-js-custom.video-js .vjs-play-control")
                                            .on("mouseenter", function (event) {
                                                $scope.showTooltip(event);
                                            }).on("mouseleave", function (event) {
                                        $scope.hideTooltip(event);
                                    }).on("focus", function (event) {
                                        $scope.showTooltip(event);
                                    }).on("blur", function (event) {
                                        $scope.hideTooltip(event);
                                    }).keydown(function (event) {
                                        if (27 === event.which) {
                                            $(".vjs-button").removeClass("vjs-tooltip-show");
                                        }
                                    });

                                    //Add playback rate tooltip and polygon
                                    $(".video-js-custom.video-js button.vjs-playback-rate")
                                        .append('<div class="vjs-tooltip" aria-hidden="true">Change playback speed</div><div class="vjs-polygon" aria-hidden="true" ></div>')
                                        .attr("aria-haspopup", "menu")
                                        .attr("id", "vjs-playback-rate-button-id")
                                        .attr("aria-controls", "vjs-playback-rate-menu-id")
                                        .addClass("vjs-hidden")
                                        .on("mouseenter", function (event) {
                                            $scope.showTooltip(event);
                                    }).on("mouseleave", function (event) {
                                        $scope.hideTooltip(event);
                                    }).on("focus", function (event) {
                                        $scope.showTooltip(event);
                                    }).on("blur", function (event) {
                                        $scope.hideTooltip(event);
                                    }).keydown(function (event) {
                                        if (27 === event.which) {
                                            $(".vjs-button").removeClass("vjs-tooltip-show");
                                        } else if (13 === event.which || 32 === event.which || 38 === event.which || 40 === event.which) {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            $(event.target).click();
                                            var keydownMenuIndex = $(".video-js-custom.video-js .vjs-playback-rate .vjs-menu .vjs-selected").index();
                                            if (keydownMenuIndex >= 0) {
                                                player.controlBar.playbackRateMenuButton.menu.focus(keydownMenuIndex);
                                            } else {
                                                var menu = player.controlBar.playbackRateMenuButton.menu;
                                                if (38 === event.which) {
                                                    menu.focus(menu.children().length - 1);
                                                } else {
                                                    menu.focus(0);
                                                }
                                            }
                                        }
                                    }).on("click", function (event) {
                                        $timeout(function () {
                                            if ($(".video-js-custom.video-js .vjs-playback-rate .vjs-menu.vjs-lock-showing").length) {
                                                var menuIndex = $(".video-js-custom.video-js .vjs-playback-rate .vjs-menu .vjs-selected").index();
                                                if (menuIndex < 0) {
                                                    menuIndex = 0;
                                                }
                                                player.controlBar.playbackRateMenuButton.menu.focus(menuIndex);
                                            } else {
                                                $(".video-js-custom.video-js .vjs-playback-rate button").focus();
                                            }
                                        });
                                    }).on("pointerdown", function (event) {
                                        event.preventDefault();
                                        event.stopPropagation();
                                    });
                                    //Playback rate menu updates
                                    $(".video-js-custom.video-js .vjs-playback-rate .vjs-menu")
                                            .attr("id", "vjs-playback-rate-menu-id")
                                            .attr("aria-labelledby", "vjs-playback-rate-button-id");
                                    $(".vjs-playback-rate .vjs-menu-item")
                                        .click(function(event){
                                            $("#vjs-playback-rate-button-id").attr("aria-expanded","false");
                                            $("#vjs-settings-playback-rate-button-id").attr("aria-expanded","false");
                                            if($('button.vjs-playback-rate').hasClass("vjs-hidden")){
                                                $scope.openSettingsDialog();
                                                $("#vjs-settings-dialog-id button.vjs-menu-speed").focus();
                                            }else{
                                                $('button.vjs-playback-rate').focus();
                                            }
                                    }).keydown(function(event){
                                        if(13===event.which || 32===event.which){
                                            $("#vjs-playback-rate-button-id").attr("aria-expanded","false");
                                            $("#vjs-settings-playback-rate-button-id").attr("aria-expanded","false");
                                            if($('button.vjs-playback-rate').hasClass("vjs-hidden")){
                                                $scope.openSettingsDialog();
                                                $("#vjs-settings-dialog-id .vjs-menu-speed").focus();
                                            }else{
                                                $('button.vjs-playback-rate').focus();
                                            }
                                        }
                                    });

                                    //add closed captions tooltip and polygon
                                    $('.video-js-custom.video-js button.vjs-subs-caps-button')
                                        .append('<div class="vjs-tooltip" aria-hidden="true">Captions and subtitles</div><div class="vjs-polygon" aria-hidden="true" ></div>')
                                        .addClass("vjs-hidden")
                                        .attr("id","vjs-subs-caps-button-id")
                                        .attr("aria-haspopup", "menu")
                                        .attr("aria-controls", "vjs-subs-caps-menu-id")
                                        .on("mouseenter", function (event) {
                                            $scope.showTooltip(event);
                                        }).on("mouseleave", function (event) {
                                        $scope.hideTooltip(event);
                                    }).on("focus", function (event) {
                                        $scope.showTooltip(event);
                                    }).on("blur", function (event) {
                                        $scope.hideTooltip(event);
                                    }).keydown(function (event) {
                                        if (27 === event.which) {
                                            $(".vjs-button").removeClass("vjs-tooltip-show");
                                        } else if (13 === event.which || 32 === event.which || 38 === event.which || 40 === event.which) {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            $(event.target).click();
                                            var keydownMenuIndex = $(".video-js-custom.video-js .vjs-subs-caps-button .vjs-menu .vjs-selected").index();
                                            if (keydownMenuIndex >= 0) {
                                                player.controlBar.subsCapsButton.menu.focus(keydownMenuIndex);
                                            } else {
                                                var menu = player.controlBar.subsCapsButton.menu;
                                                if (38 === event.which) {
                                                    menu.focus(menu.children().length - 1);
                                                } else {
                                                    menu.focus(0);
                                                }
                                            }
                                        }
                                    }).on("click", function (event) {
                                        $timeout(function () {
                                            if ($(".video-js-custom.video-js .vjs-subs-caps-button .vjs-menu.vjs-lock-showing").length) {
                                                var menuIndex = $(".video-js-custom.video-js .vjs-subs-caps-button .vjs-menu .vjs-selected").index();
                                                if (menuIndex < 0) {
                                                    menuIndex = 0;
                                                }
                                                player.controlBar.subsCapsButton.menu.focus(menuIndex);
                                            } else {
                                                $(".video-js-custom.video-js .vjs-subs-caps-button button").focus();
                                            }
                                        });
                                    }).on("pointerdown", function (event) {
                                        event.preventDefault();
                                        event.stopPropagation();
                                    });
                                    $(".video-js-custom.video-js .vjs-subs-caps-button .vjs-menu")
                                            .attr("id", "vjs-subs-caps-menu-id")
                                            .attr("aria-labelledby", "vjs-subs-caps-button-id");
                                    $(".vjs-subs-caps-button .vjs-menu-item")
                                      .click(function(event){
                                        $("#vjs-subs-caps-button-id").attr("aria-expanded","false");
                                        $("#vjs-settings-subs-caps-button-id").attr("aria-expanded","false");
                                        if($('button.vjs-subs-caps-button').hasClass("vjs-hidden")){
                                            $scope.openSettingsDialog();
                                            $("#vjs-settings-dialog-id button.vjs-menu-cc").focus();
                                        }else{
                                            $('button.vjs-subs-caps-button').focus();
                                        }
                                    }).keydown(function(event){
                                        //console.log("keydown which: "+event.which);
                                        if(13===event.which || 32===event.which){
                                            $("#vjs-subs-caps-button-id").attr("aria-expanded","false");
                                            $("#vjs-settings-subs-caps-button-id").attr("aria-expanded","false");
                                            if($('button.vjs-subs-caps-button').hasClass("vjs-hidden")){
                                                $scope.openSettingsDialog();
                                                $("#vjs-settings-dialog-id button.vjs-menu-cc").focus();
                                            }else{
                                                $('button.vjs-subs-caps-button').focus();
                                            }
                                        }
                                    });


                                    //add audio tooltip and polygon
                                    $(
                                            '.video-js-custom.video-js .vjs-audio-button button'
                                            ).append(
                                            '<div class="vjs-tooltip" aria-hidden="true">Audio track</div><div class="vjs-polygon" aria-hidden="true" ></div>'
                                            );

                                    $(".video-js-custom.video-js .vjs-audio-button button")
                                            .addClass("vjs-hidden")
                                            .attr("id","vjs-audio-button-id")
                                            .attr("aria-haspopup","menu")
                                            .attr("aria-controls", "vjs-audio-menu-id")
                                            .on("mouseenter", function (event) {
                                                $scope.showTooltip(event);
                                            }).on("mouseleave", function (event) {
                                        $scope.hideTooltip(event);
                                    }).on("focus", function (event) {
                                        $scope.showTooltip(event);
                                    }).on("blur", function (event) {
                                        $scope.hideTooltip(event);
                                    }).keydown(function (event) {
                                        if (27 === event.which) {
                                            $(".vjs-button").removeClass("vjs-tooltip-show");
                                        } else if (13 === event.which || 32 === event.which || 38 === event.which || 40 === event.which) {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            $(event.target).click();
                                            var keydownMenuIndex = $(".video-js-custom.video-js .vjs-audio-button .vjs-menu .vjs-selected").index();
                                            if (keydownMenuIndex >= 0) {
                                                player.controlBar.audioTrackButton.menu.focus(keydownMenuIndex);
                                            } else {
                                                var menu = player.controlBar.audioTrackButton.menu;
                                                if (38 === event.which) {
                                                    menu.focus(menu.children().length - 1);
                                                } else {
                                                    menu.focus(0);
                                                }
                                            }
                                        }
                                    }).on("click", function (event) {
                                        $timeout(function () {
                                            if ($(".video-js-custom.video-js .vjs-audio-button .vjs-menu.vjs-lock-showing").length) {
                                                var menuIndex = $(".video-js-custom.video-js .vjs-audio-button .vjs-menu .vjs-selected").index();
                                                if (menuIndex < 0) {
                                                    menuIndex = 0;
                                                }
                                                player.controlBar.audioTrackButton.menu.focus(menuIndex);
                                            } else {
                                                $(".video-js-custom.video-js .vjs-audio-button button").focus();
                                            }
                                        });
                                    }).on("pointerdown", function (event) {
                                        event.preventDefault();
                                        event.stopPropagation();
                                    });
                                    $(".video-js-custom.video-js .vjs-audio-button .vjs-menu")
                                            .attr("id", "vjs-audio-menu-id")
                                            .attr("aria-labelledby", "vjs-audio-button-id");

                                    //Add skip backward tooltip and polygon
                                    $(
                                            '.video-js-custom.video-js .vjs-skip-backward-10'
                                            ).append(
                                            '<span class="vjs-tooltip" aria-hidden="true">Step back 10 seconds</span><div class="vjs-polygon" aria-hidden="true" ></div>'
                                            );
                                    $(".video-js-custom.video-js .vjs-skip-backward-10")
                                            .on("mouseenter", function (event) {
                                                $scope.showTooltip(event);
                                            }).on("mouseleave", function (event) {
                                        $scope.hideTooltip(event);
                                    }).on("focus", function (event) {
                                        $scope.showTooltip(event);
                                    }).on("blur", function (event) {
                                        $scope.hideTooltip(event);
                                    }).keydown(function (event) {
                                        if (27 === event.which) {
                                            $(".vjs-button").removeClass("vjs-tooltip-show");
                                        }
                                    });

                                    //Add skip forward tooltip and polygon
                                    $('.video-js-custom.video-js .vjs-skip-forward-10')
                                            .append('<span class="vjs-tooltip" aria-hidden="true">Step forward 10 seconds</span><div class="vjs-polygon" aria-hidden="true" ></div>');
                                    $(".video-js-custom.video-js .vjs-skip-forward-10")
                                            .on("mouseenter", function (event) {
                                                $scope.showTooltip(event);
                                            })
                                            .on("mouseleave", function (event) {
                                                $scope.hideTooltip(event);
                                            })
                                            .on("focus", function (event) {
                                                $scope.showTooltip(event);
                                            })
                                            .on("blur", function (event) {
                                                $scope.hideTooltip(event);
                                            })
                                            .keydown(function (event) {
                                                if (27 === event.which) {
                                                    $(".vjs-button").removeClass("vjs-tooltip-show");
                                                }
                                            });
                                    //Create settings button
                                    $(  '<div class="vjs-settings vjs-menu-button vjs-menu-button-popup vjs-control vjs-button">'+
                                        '<button id="vjs-settings-button-id" class="vjs-settings-button vjs-control vjs-button" aria-haspopup="menu" aria-controls="vjs-settings-dialog-id" aria-expanded="false" type="button">'+
                                        '<span class="vjs-icon-placeholder" aria-hidden="true"></span>'+
                                        '<span class="vjs-control-text" aria-live="polite">Settings</span>'+
                                        '<div class="vjs-tooltip" aria-hidden="true">Settings</div>'+
                                        '<div class="vjs-polygon" aria-hidden="true"></div>'+
                                        '</button>'+
                                        '</div>').insertBefore(".vjs-fullscreen-control.vjs-control.vjs-button");

                                    $(".video-js-custom.video-js .vjs-settings-button")
                                      .on("mouseenter",function(event) {
                                        $scope.showTooltip(event);
                                    }).on("mouseleave",function(event) {
                                        $scope.hideTooltip(event);
                                    }).on("focus",function(event) {
                                        $scope.showTooltip(event);
                                    }).on("blur",function(event) {
                                        $scope.hideTooltip(event);
                                    }).keydown(function(event) {
                                        if(27===event.which){
                                            $(".vjs-button").removeClass("vjs-tooltip-show");
                                        }
                                    }).mousedown(function(event){
                                        $scope.toggleSettingsDialog();
                                    }).keypress(function(event){
                                        if(event.which===32 || event.which===13){
                                            event.preventDefault();
                                            $scope.toggleSettingsDialog();
                                        }
                                    });

                                    //Create settings dialog
                                    $(  '<div id="vjs-settings-dialog-id" class="vjs-settings-dialog vjs-modal-dialog" aria-labelledby="vjs-settings-button-id">'+
                                        '<div class="vjs-menu-header"><div class="vjs-menu-title">Settings</div><button class="vjs-button vjs-menu-xmark" tabindex="0" aria-label="Close" type="button"><div class="vjs-icon-placeholder"></div></button></div>'+
                                        '<div class="vjs-menu-divider"></div>'+
                                        '<div class="vjs-menu-section">'+
                                        '<button class="vjs-menu-item vjs-menu-cc" id="vjs-settings-subs-caps-button-id" type="button" tabindex="0" '+
                                        '   aria-label="Captions and Subtitles" aria-haspopup="menu" aria-controls="vjs-subs-caps-menu-id" aria-expanded="false">'+
                                        '       <div class="vjs-menu-icon"></div><div class="vjs-menu-action">Captions & Subtitles</div><div class="vjs-menu-wrapper"><div class="vjs-menu-value">Off</div><div class="vjs-menu-chevron-right"></div></div>'+
                                        '</button>'+
                                        '<button class="vjs-menu-item vjs-menu-ad" id="vjs-settings-audio-descriptions-button-id" type="button" tabindex="0" '+
                                        '   aria-label="Audio Descriptions" aria-haspopup="menu" aria-controls="vjs-audio-descriptions-menu-id" aria-expanded="false">'+
                                        '       <div class="vjs-menu-icon"></div><div class="vjs-menu-action">Audio Descriptions</div><div class="vjs-menu-wrapper"><div class="vjs-menu-value">Off</div><div class="vjs-menu-chevron-right"></div></div>'+
                                        '</button>'+
                                        '<button class="vjs-menu-item vjs-menu-audio" id="vjs-settings-audio-button-id" type="button" tabindex="0" '+
                                        '   aria-label="Audio" aria-haspopup="menu" aria-controls="vjs-audio-menu-id" aria-expanded="false">'+
                                        '       <div class="vjs-menu-icon"></div><div class="vjs-menu-action">Audio Tracks</div><div class="vjs-menu-wrapper"><div class="vjs-menu-value">Off</div><div class="vjs-menu-chevron-right"></div></div>'+
                                        '</button>'+
                                        '<button class="vjs-menu-item vjs-menu-speed" id="vjs-settings-playback-rate-button-id" type="button" tabindex="0" '+
                                        '   aria-label="Playback Speed" aria-haspopup="menu" aria-controls="vjs-playback-rate-menu-id" aria-expanded="false">'+
                                        '       <div class="vjs-menu-icon"></div><div class="vjs-menu-action">Playback Speed</div><div class="vjs-menu-wrapper"><div class="vjs-menu-value">1x</div><div class="vjs-menu-chevron-right"></div></div>'+
                                        '</button>'+
                                        '</div>').insertAfter(".vjs-settings-button.vjs-control.vjs-button");

                                    $("#vjs-settings-dialog-id .vjs-menu-xmark")
                                      .click(function(event){
                                        $scope.closeSettingsDialog();
                                        $timeout(function(){
                                            $("#vjs-settings-button-id").focus();
                                        });
                                    }).keypress(function(event){
                                        if(event.which===32 || event.which===13){
                                            event.preventDefault();
                                            $scope.closeSettingsDialog();
                                            $("#vjs-settings-button-id").focus();
                                        }
                                    });
                                    $("#vjs-settings-dialog-id button.vjs-menu-ad")
                                      .click(function(event){
                                        $scope.closeSettingsDialog();
                                        $scope.toggleADDialog();
                                        $("#vjs-audio-descriptions-button-id").attr("aria-expanded","true");
                                        $("#vjs-settings-audio-descriptions-button-id").attr("aria-expanded","true");
                                    }).keypress(function(event){
                                        if(event.which===32 || event.which===13){
                                            event.preventDefault();
                                            $scope.closeSettingsDialog();
                                            $scope.toggleADDialog();
                                            $("#vjs-audio-descriptions-button-id").attr("aria-expanded","true");
                                            $("#vjs-settings-audio-descriptions-button-id").attr("aria-expanded","true");
                                        }
                                    });
                                    $("#vjs-settings-dialog-id button.vjs-menu-cc")
                                      .click(function(event){
                                        $scope.closeSettingsDialog();
                                        $scope.toggleCCDialog();
                                        $("#vjs-subs-caps-button-id").attr("aria-expanded","true");
                                        $("#vjs-settings-subs-caps-button-id").attr("aria-expanded","true");
                                    }).keypress(function(event){
                                        if(event.which===32 || event.which===13){
                                            event.preventDefault();
                                            $scope.closeSettingsDialog();
                                            $scope.toggleCCDialog();
                                            $("#vjs-subs-caps-button-id").attr("aria-expanded","true");
                                            $("#vjs-settings-subs-caps-button-id").attr("aria-expanded","true");
                                        }
                                    });
                                    $("#vjs-settings-dialog-id button.vjs-menu-audio")
                                      .click(function(event){
                                        $scope.closeSettingsDialog();
                                        $scope.toggleAudioDialog();
                                        $("#vjs-audio-button-id").attr("aria-expanded","true");
                                        $("#vjs-settings-audio-button-id").attr("aria-expanded","true");
                                    }).keypress(function(event){
                                        if(event.which===32 || event.which===13){
                                            event.preventDefault();
                                            $scope.closeSettingsDialog();
                                            $scope.toggleAudioDialog();
                                            $("#vjs-audio-button-id").attr("aria-expanded","true");
                                            $("#vjs-settings-audio-button-id").attr("aria-expanded","true");
                                        }
                                    });
                                    $("#vjs-settings-dialog-id button.vjs-menu-speed")
                                      .click(function(event){
                                        $scope.closeSettingsDialog();
                                        $scope.toggleSpeedDialog();
                                        $("#vjs-playback-rate-button-id").attr("aria-expanded","true");
                                        $("#vjs-settings-playback-rate-button-id").attr("aria-expanded","true");
                                    }).keypress(function(event){
                                        if(event.which===32 || event.which===13){
                                            event.preventDefault();
                                            $scope.closeSettingsDialog();
                                            $scope.toggleSpeedDialog();
                                            $("#vjs-playback-rate-button-id").attr("aria-expanded","true");
                                            $("#vjs-settings-playback-rate-button-id").attr("aria-expanded","true");
                                        }
                                    }).keydown(function(event){
                                        if(event.which===9 && !event.shiftKey){
                                            event.preventDefault();
                                            $(".vjs-settings-button").focus();
                                        }
                                    });


                                    //Create More Actions button
                                    $(  '<div class="vjs-more-actions vjs-menu-button vjs-menu-button-popup vjs-control vjs-button">'+
                                        '<button id="vjs-more-actions-button-id" class="vjs-more-actions-button vjs-control vjs-button" aria-haspopup="menu" aria-controls="vjs-more-actions-dialog-id" aria-expanded="false" type="button">'+
                                        '<span class="vjs-icon-placeholder" aria-hidden="true"></span>'+
                                        '<span class="vjs-control-text" aria-live="polite">More Actions</span>'+
                                        '<div class="vjs-tooltip" aria-hidden="true">More Actions</div>'+
                                        '<div class="vjs-polygon" aria-hidden="true"></div>'+
                                        '</button>'+
                                        '</div>').insertAfter(".vjs-skip-forward-10.vjs-control.vjs-button");

                                    $(".video-js-custom.video-js .vjs-more-actions-button")
                                      .on("mouseenter",function(event) {
                                        $scope.showTooltip(event);
                                    }).on("mouseleave",function(event) {
                                        $scope.hideTooltip(event);
                                    }).on("focus",function(event) {
                                        $scope.showTooltip(event);
                                    }).on("blur",function(event) {
                                        $scope.hideTooltip(event);
                                    }).keydown(function(event) {
                                        if(27===event.which){
                                            $(".vjs-button").removeClass("vjs-tooltip-show");
                                        }
                                    }).mousedown(function(event){
                                        $scope.toggleMoreActionsDialog();
                                    }).keypress(function(event){
                                        if(event.which===32 || event.which===13){
                                            event.preventDefault();
                                            $scope.toggleMoreActionsDialog();
                                        }
                                    });

                                    //Create More Actions dialog
                                    $(  '<div id="vjs-more-actions-dialog-id" class="vjs-more-actions-dialog vjs-modal-dialog" aria-labelledby="vjs-more-actions-button-id">'+
                                        '<div class="vjs-menu-header"><div class="vjs-menu-title">More Actions</div><button class="vjs-button vjs-menu-xmark" tabindex="0" aria-label="Close" type="button"><div class="vjs-icon-placeholder"></div></button></div>'+
                                        '<div class="vjs-menu-divider"></div>'+
                                        '<div class="vjs-menu-section">'+
                                        '<button class="vjs-menu-item vjs-menu-sb10" type="button" tabindex="0" aria-label="Step Back 10 Seconds">'+
                                        '       <div class="vjs-menu-icon"></div><div class="vjs-menu-action">Step Back 10 Seconds</div>'+
                                        '</button>'+
                                        '<button class="vjs-menu-item vjs-menu-sf10" type="button" tabindex="0" aria-label="Step Forward 10 Seconds">'+
                                        '       <div class="vjs-menu-icon"></div><div class="vjs-menu-action">Step Forward 10 Seconds</div>'+
                                        '</button>'+
                                        '</div>').insertAfter(".vjs-more-actions-button.vjs-control.vjs-button");

                                    $("#vjs-more-actions-dialog-id .vjs-menu-xmark")
                                      .mousedown(function(event){
                                        $scope.closeMoreActionsDialog();
                                        $timeout(function(){
                                            $("#vjs-more-actions-button-id").focus();
                                        });
                                    }).keypress(function(event){
                                        if(event.which===32 || event.which===13){
                                            event.preventDefault();
                                            $scope.closeMoreActionsDialog();
                                            $("#vjs-more-actions-button-id").focus();
                                        }
                                    });
                                    $("#vjs-more-actions-dialog-id button.vjs-menu-sb10")
                                      .mousedown(function(event){
                                        $scope.closeMoreActionsDialog();
                                        $("button.vjs-skip-backward-10").click();
                                        $("#vjs-more-actions-button-id").focus();
                                    }).keypress(function(event){
                                        if(event.which===32 || event.which===13){
                                            event.preventDefault();
                                            $scope.closeMoreActionsDialog();
                                            $("button.vjs-skip-backward-10").click();
                                            $("#vjs-more-actions-button-id").focus();
                                        }
                                    });
                                    $("#vjs-more-actions-dialog-id button.vjs-menu-sf10")
                                      .mousedown(function(event){
                                        $scope.closeMoreActionsDialog();
                                        $("button.vjs-skip-forward-10").click();
                                        $("#vjs-more-actions-button-id").focus();
                                    }).keypress(function(event){
                                        if(event.which===32 || event.which===13){
                                            event.preventDefault();
                                            $scope.closeMoreActionsDialog();
                                            $("button.vjs-skip-forward-10").click();
                                            $("#vjs-more-actions-button-id").focus();
                                        }
                                    }).keydown(function(event){
                                        if(event.which===9 && !event.shiftKey){
                                            event.preventDefault();
                                            $(".vjs-more-actions-button").focus();
                                        }
                                    });


                                    //Add audio descriptions tooltip and polygon
                                    $('.video-js-custom.video-js button.vjs-descriptions-button')
                                            .append('<span class="vjs-tooltip" aria-hidden="true">Audio Descriptions</span><div class="vjs-polygon" aria-hidden="true" ></div>');
                                    $('.video-js-custom.video-js button.vjs-descriptions-button')
                                            .addClass("vjs-hidden")
                                            .attr("id","vjs-audio-descriptions-button-id")
                                            .attr("aria-haspopup", "menu")
                                            .attr("aria-controls", "vjs-audio-descriptions-menu-id")
                                            .on("mouseenter", function (event) {
                                                $scope.showTooltip(event);
                                            }).on("mouseleave", function (event) {
                                        $scope.hideTooltip(event);
                                    }).on("focus", function (event) {
                                        $scope.showTooltip(event);
                                    }).on("blur", function (event) {
                                        $scope.hideTooltip(event);
                                    }).keydown(function (event) {
                                        if (27 === event.which) {
                                            $(".vjs-button").removeClass("vjs-tooltip-show");
                                        } else if (13 === event.which || 32 === event.which || 38 === event.which || 40 === event.which) {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            $(event.target).click();
                                            var keydownMenuIndex = $(".video-js-custom.video-js .vjs-descriptions-button .vjs-menu .vjs-selected").index();
                                            if (keydownMenuIndex >= 0) {
                                                player.controlBar.descriptionsButton.menu.focus(keydownMenuIndex);
                                            } else {
                                                var menu = player.controlBar.descriptionsButton.menu;
                                                if (38 === event.which) {
                                                    menu.focus(menu.children().length - 1);
                                                } else {
                                                    menu.focus(0);
                                                }
                                            }
                                        }
                                    }).on("click", function (event) {
                                        $timeout(function () {
                                            if ($(".video-js-custom.video-js .vjs-descriptions-button .vjs-menu.vjs-lock-showing").length) {
                                                var menuIndex = $(".video-js-custom.video-js .vjs-descriptions-button .vjs-menu .vjs-selected").index();
                                                if (menuIndex < 0) {
                                                    menuIndex = 0;
                                                }
                                                player.controlBar.descriptionsButton.menu.focus(menuIndex);
                                            } else {
                                                $(".video-js-custom.video-js .vjs-descriptions-button button").focus();
                                            }
                                        });
                                    }).on("pointerdown", function (event) {
                                        event.preventDefault();
                                        event.stopPropagation();
                                    });
                                    // Audio Descriptions Menu Updates
                                    $(".video-js-custom.video-js .vjs-descriptions-button .vjs-menu")
                                            .attr("id", "vjs-audio-descriptions-menu-id")
                                            .attr("aria-labelledby", "vjs-audio-descriptions-button-id");
                                    $(".vjs-descriptions-button .vjs-menu-item")
                                        .click(function(event){
                                            $("#vjs-audio-descriptions-button-id").attr("aria-expanded","false");
                                            $("#vjs-settings-audio-descriptions-button-id").attr("aria-expanded","false");
                                            if($('button.vjs-descriptions-button').hasClass("vjs-hidden")){
                                                $scope.openSettingsDialog();
                                                $("#vjs-settings-dialog-id button.vjs-menu-ad").focus();
                                            }else{
                                                $('button.vjs-descriptions-button').focus();
                                            }
                                    }).keydown(function(event){
                                        //console.log("keydown which: "+event.which);
                                        if(13===event.which || 32===event.which){
                                            $("#vjs-audio-descriptions-button-id").attr("aria-expanded","false");
                                            $("#vjs-settings-audio-descriptions-button-id").attr("aria-expanded","false");
                                            if($('button.vjs-descriptions-button').hasClass("vjs-hidden")){
                                                $scope.openSettingsDialog();
                                                $("#vjs-settings-dialog-id button.vjs-menu-ad").focus();
                                            }else{
                                                $('button.vjs-descriptions-button').focus();
                                            }
                                        }
                                    });

                                    //Add fullscreen tooltip and polygon
                                    $(
                                            '.video-js-custom.video-js .vjs-fullscreen-control'
                                            ).append(
                                            '<span class="vjs-tooltip" aria-hidden="true"></span><div class="vjs-polygon" aria-hidden="true" ></div>'
                                            );
                                    $(".video-js-custom.video-js .vjs-fullscreen-control")
                                            .on("mouseenter", function (event) {
                                                $scope.showTooltip(event);
                                            })
                                            .on("mouseleave", function (event) {
                                                $scope.hideTooltip(event);
                                            })
                                            .on("focus", function (event) {
                                                $scope.showTooltip(event);
                                            })
                                            .on("blur", function (event) {
                                                $scope.hideTooltip(event);
                                            })
                                            .keydown(function (event) {
                                                if (27 === event.which) {
                                                    $(".vjs-button").removeClass("vjs-tooltip-show");
                                                }
                                            });

                                    //Update vjs-control-text items
                                    $('.video-js-custom.video-js .vjs-skip-backward-10 .vjs-control-text').html('Step Back 10 Seconds');
                                    $('.video-js-custom.video-js .vjs-skip-forward-10 .vjs-control-text').html('Step Forward 10 Seconds');

                                    $('.video-js-custom.video-js .vjs-subs-caps-button .vjs-control-text').html('Captions And Subtitles');
                                    $(".video-js-custom.video-js .vjs-playback-rate .vjs-control-text").html("Change Playback Speed");

                                    //Add aria labels to various buttons
                                    $('.vjs-big-play-button').attr('aria-label', 'Play');

                                    $(".video-js-custom.video-js .vjs-big-play-button")
                                      .keydown(function (event) {
                                        if (27 === event.which) {
                                            console.log("Big play Button Escape!");
                                            $(".vjs-button").removeClass("vjs-tooltip-show");
                                        }
                                    });

                                    //Modify subs caps dialog
                                    $(".video-js-custom.video-js .vjs-subs-caps-button .vjs-menu-content .vjs-menu-item-text:contains('captions off')").html("Off");

                                    //Create caps toggle button
                                    $(  '<button class="vjs-subs-caps-button-toggle vjs-control vjs-button" aria-pressed="false" type="button">'+
                                        '<span class="vjs-icon-placeholder" aria-hidden="true"></span>'+
                                        '<span class="vjs-control-text" aria-live="polite">CC captions and subtitles</span>'+
                                        '<div class="vjs-tooltip" aria-hidden="true">Captions and subtitles</div>'+
                                        '<div class="vjs-polygon" aria-hidden="true"></div>'+
                                        '</button>').insertBefore("div.vjs-subs-caps-button");

                                    $(".video-js-custom.video-js .vjs-subs-caps-button-toggle")
                                            .on("mouseenter", function (event) {
                                                $scope.showTooltip(event);
                                            })
                                            .on("mouseleave", function (event) {
                                                $scope.hideTooltip(event);
                                            })
                                            .on("focus", function (event) {
                                                $scope.showTooltip(event);
                                            })
                                            .on("blur", function (event) {
                                                $scope.hideTooltip(event);
                                            })
                                            .keydown(function (event) {
                                                if (27 === event.which) {
                                                    $(".vjs-button").removeClass("vjs-tooltip-show");
                                                }
                                            })
                                            .mousedown(function (event) {
                                                $scope.toggleCC();
                                            })
                                            .keypress(function (event) {
                                                if (event.which === 32 || event.which === 13) {
                                                    $scope.toggleCC();
                                                }
                                            });

                                    //Create audio description toggle button
                                    $(  '<button class="vjs-audio-descriptions-button-toggle vjs-control vjs-button" aria-pressed="false" type="button">'+
                                        '<span class="vjs-icon-placeholder" aria-hidden="true"></span>'+
                                        '<span class="vjs-control-text" aria-live="polite">AD audio descriptions</span>'+
                                        '<div class="vjs-tooltip" aria-hidden="true">Audio descriptions</div>'+
                                        '<div class="vjs-polygon" aria-hidden="true"></div>'+
                                        '</button>').insertAfter(".vjs-subs-caps-button.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button");

                                    $(".video-js-custom.video-js .vjs-audio-descriptions-button-toggle")
                                      .on("mouseenter",function(event) {
                                        $scope.showTooltip(event);
                                    }).on("mouseleave",function(event) {
                                        $scope.hideTooltip(event);
                                    }).on("focus",function(event) {
                                        $scope.showTooltip(event);
                                    }).on("blur",function(event) {
                                        $scope.hideTooltip(event);
                                    }).keydown(function(event) {
                                        if(27===event.which){
                                            $(".vjs-button").removeClass("vjs-tooltip-show");
                                        }
                                    }).mousedown(function(event){
                                        $scope.toggleAudioDescriptions();
                                    }).keypress(function(event){
                                        if(event.which===32 || event.which===13){
                                            event.preventDefault();
                                            $scope.toggleAudioDescriptions();
                                        }
                                    });

                                    //Create filler div
                                    $('<div class="vjs-filler"></div>').insertAfter(".vjs-duration.vjs-time-control.vjs-control");

                                    //Reorder DOM vjs-subs-caps-button
                                    $('div.vjs-progress-control').insertBefore('button.vjs-play-control');
                                    $('button.vjs-subs-caps-button-toggle').insertAfter('div.vjs-filler');
                                    $('button.vjs-audio-descriptions-button-toggle').insertAfter('button.vjs-subs-caps-button-toggle');
                                    $('div.vjs-subs-caps-button').insertAfter('button.vjs-audio-descriptions-button-toggle');
                                    $('div.vjs-descriptions-button').insertAfter('div.vjs-subs-caps-button');
                                    $('div.vjs-audio-button').insertAfter('div.vjs-descriptions-button');
                                    $('div.vjs-playback-rate').insertAfter('div.vjs-audio-button');
                                    $('div.vjs-settings').insertAfter('div.vjs-playback-rate');
                                    $('button.vjs-fullscreen-control').insertAfter('div.vjs-settings');

                                    // Escaping Tooltips from scrubber
                                    $(".video-js-custom.video-js .vjs-progress-holder")
                                      .keydown(function (event) {
                                        if (27 === event.which) {
                                            $(".vjs-button").removeClass("vjs-tooltip-show");
                                        }
                                    });

                                    //Catch menu keydown and set focus
                                    $(".vjs-menu .vjs-menu-item").on("keydown.ssplayervsjdirective", function (event) {
                                        if (27 === event.which) {
                                            $(".vjs-menu.vjs-lock-showing").parent().children("button:visible").focus();
                                        }
                                    });

                                    //Prevent tooltip clicks
                                    $(".vjs-tooltip").on('click', function (e) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    });

                                    //Prevent polygon clicks
                                    $(".vjs-polygon").on('click', function (e) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    });

                                    //Start player resizeOoserver
                                    $scope.playerEl = player.el();
                                    $scope.resizeObserver.observe($scope.playerEl);

                                    //start constantUpdates
                                    $scope.makeUpdate();
                                });
                            }
                        };
                        $scope.resizeObserver = new ResizeObserver((entries) => {
                            for (var entry of entries) {
                                if (entry.contentBoxSize) {
                                    var newWidth = parseInt(entry.contentBoxSize[0].inlineSize);
                                    var newSize = "";
                                    if (newWidth <= 399) {
                                        newSize = "XS";
                                    } else if (newWidth <= 479) {
                                        newSize = "S";
                                    } else if (newWidth <= 1023) {
                                        newSize = "M";
                                    } else {
                                        newSize = "L";
                                    }
                                    if ($(".video-js-custom.video-js:not(.vjs-size-" + newSize + ")")) {
                                        $(".video-js-custom.video-js").removeClass("vjs-size-XS vjs-size-S vjs-size-M vjs-size-L").addClass("vjs-size-" + newSize);
                                    }
                                    if (newSize === "XS" || newSize === "S") {
                                        $(".video-js-custom.video-js:not(.vjs-volume-popover)").addClass("vjs-volume-popover");
                                    } else {
                                        $(".video-js-custom.video-js.vjs-volume-popover").removeClass("vjs-volume-popover");
                                    }
                                    if (newSize === "M") {
                                        var audioBarLength = Math.round(((newWidth - 480) / (1023 - 480) * 25) + 75);
                                        if (audioBarLength !== $(".video-js-custom.video-js .vjs-filler").width()) {
                                            $(".video-js-custom.video-js .vjs-volume-bar.vjs-slider-horizontal").width(audioBarLength);
                                            $(".video-js-custom.video-js .vjs-filler").width(audioBarLength);
                                        }
                                    } else {
                                        if ($(".video-js-custom.video-js .vjs-filler").get(0).style.width) {
                                            $(".video-js-custom.video-js .vjs-volume-bar.vjs-slider-horizontal").css("width", "");
                                            $(".video-js-custom.video-js .vjs-filler").css("width", "");
                                        }
                                    }
                                    if(newSize !== "XS"){
                                        $scope.closeMoreActionsDialog();
                                    }
                                    if (!videojs.browser.IS_IOS) {
                                        var fontSize = null;
                                        switch (newSize) {
                                            case 'XS':
                                                fontSize = "14.00";
                                                break;
                                            case 'S':
                                                fontSize = (((newWidth - 400) * 0.025316456) + 14).toFixed(2);
                                                break;
                                            case 'M':
                                                fontSize = (((newWidth - 480) * 0.007366483) + 16).toFixed(2);
                                                break;
                                            case 'L':
                                                fontSize = (((newWidth - 1024) * 0.017857143) + 20).toFixed(2);
                                                if (newWidth > 1920) {
                                                    fontSize = "36.00";
                                                }
                                                break;
                                            default:
                                        }
                                        var currentFontPercent = $(".vjs-font-percent > select").val();
                                        if (currentFontPercent && currentFontPercent !== "1.00") {
                                            fontSize = (parseFloat(fontSize) * parseFloat(currentFontPercent)).toFixed(2);
                                        }
                                        if (fontSize !== $scope.currentTextTrackFontSize) {
                                            //console.log("fontSize change from " +$scope.currentTextTrackFontSize + " to " + fontSize );
                                            $("#video-js-captions-styles").html(
                                                    ".video-js-custom.video-js .vjs-text-track-display .vjs-text-track-cue {font-size: " + fontSize + "px !important;}"
                                                    );
                                            $scope.currentTextTrackFontSize = fontSize;
                                        }
                                        if (newWidth !== $scope.currentWidth) {
                                            //console.log("update textTracks");
                                            $scope.currentWidth = newWidth;
                                            player.trigger('playerresize');
                                        }
                                    }
                                }
                            }
                        });

                        $scope.makeUpdate = function () {
                            if ($(".video-js-custom.video-js .vjs-play-progress-bar").css('width') !== $(".video-js-custom.video-js .vjs-play-progress").css("width")) {
                                $(".video-js-custom.video-js .vjs-play-progress-bar").css('width', $(".video-js-custom.video-js .vjs-play-progress").css("width"));
                            }
                            var progressHolder = $(
                                    ".video-js-custom.video-js .vjs-progress-holder"
                                    );
                            var tooltips = $(".vjs-tooltip");
                            $.each(tooltips, function () {
                                $(this).css("left", "");
                                var tooltipWidth = $(this).outerWidth();
                                var offset = Math.round(tooltipWidth / 2);
                                var tooltipParent = $(this).parent();
                                var parentOffset = Math.round(tooltipParent.outerWidth() / 2);
                                var left = tooltipParent.offset().left + parentOffset;
                                var tooltipLeftDif = parseInt(
                                        left - progressHolder.offset().left
                                        );
                                if (tooltipLeftDif < 10) {
                                    tooltipLeftDif = 10;
                                }
                                var tooltipRightDif = parseInt(
                                        progressHolder.offset().left +
                                        progressHolder.width() -
                                        left
                                        );
                                if (tooltipRightDif < 10) {
                                    tooltipRightDif = 10;
                                }
                                if (tooltipLeftDif < offset) {
                                    offset = tooltipLeftDif - parentOffset;
                                    if (offset > 0) {
                                        $(this).css("left", "-" + offset + "px");
                                    }
                                } else if (tooltipRightDif < offset) {
                                    offset = 2 * offset - tooltipRightDif - parentOffset;
                                    if (offset > 0) {
                                        $(this).css("left", "-" + offset + "px");
                                    }
                                }
                            });
                            if($(".video-js-custom.video-js.vjs-showing-menu").length){
                                $(".video-js-custom.video-js:not(:has(.vjs-lock-showing))").removeClass("vjs-showing-menu");
                            }else{
                                $(".video-js-custom.video-js:has(.vjs-lock-showing)").addClass("vjs-showing-menu");
                            }
                            //Update textTrackDisplay when toolbar changes visibility
                            if ($scope.hidingToolbar) {
                                if ($(".video-js-custom.video-js:not(.vjs-playing)").length
                                        || $(".video-js-custom.video-js:not(.vjs-user-inactive)").length) {
                                    $scope.hidingToolbar = false;
                                    $scope.updateTextTrackDisplay();
                                }
                            } else {
                                if ($(".video-js-custom.video-js.vjs-playing.vjs-user-inactive").length) {
                                    $scope.hidingToolbar = true;
                                    $scope.updateTextTrackDisplay();
                                }
                            }
                            if($("#vjs-subs-caps-button-id").hasClass("vjs-hidden")){
                                if ($("#vjs-subs-caps-menu-id").attr("aria-labelledby") !== "vjs-settings-subs-caps-button-id") {
                                    $("#vjs-subs-caps-menu-id").attr("aria-labelledby","vjs-settings-subs-caps-button-id");
                                }
                            }else{
                                if ($("#vjs-subs-caps-menu-id").attr("aria-labelledby") !== "vjs-subs-caps-button-id") {
                                    $("#vjs-subs-caps-menu-id").attr("aria-labelledby","vjs-subs-caps-button-id");
                                }
                            }
                            if($("#vjs-audio-descriptions-button-id").hasClass("vjs-hidden")){
                                if ($("#vjs-audio-descriptions-menu-id").attr("aria-labelledby") !== "vjs-settings-audio-descriptions-button-id") {
                                    $("#vjs-audio-descriptions-menu-id").attr("aria-labelledby","vjs-settings-audio-descriptions-button-id");
                                }
                            }else{
                                if ($("#vjs-audio-descriptions-menu-id").attr("aria-labelledby") !== "vjs-audio-descriptions-button-id") {
                                    $("#vjs-audio-descriptions-menu-id").attr("aria-labelledby","vjs-audio-descriptions-button-id");
                                }
                            }
                            if($("#vjs-audio-button-id").hasClass("vjs-hidden")){
                                if ($("#vjs-audio-menu-id").attr("aria-labelledby") !== "vjs-settings-audio-button-id") {
                                    $("#vjs-audio-menu-id").attr("aria-labelledby","vjs-settings-audio-button-id");
                                }
                            }else{
                                if ($("#vjs-audio-menu-id").attr("aria-labelledby") !== "vjs-audio-button-id") {
                                    $("#vjs-audio-menu-id").attr("aria-labelledby","vjs-audio-button-id");
                                }
                            }
                            if($("#vjs-playback-rate-button-id").hasClass("vjs-hidden")){
                                if ($("#vjs-playback-rate-menu-id").attr("aria-labelledby") !== "vjs-settings-playback-rate-button-id") {
                                    $("#vjs-playback-rate-menu-id").attr("aria-labelledby","vjs-settings-playback-rate-button-id");
                                }
                            }else{
                                if ($("#vjs-playback-rate-menu-id").attr("aria-labelledby") !== "vjs-playback-rate-button-id") {
                                    $("#vjs-playback-rate-menu-id").attr("aria-labelledby","vjs-playback-rate-button-id");
                                }
                            }
                            if(!$scope.captionsIncluded && !$scope.subtitlesIncluded && !$scope.audioDescriptionsIncluded && !$scope.audioTextDescriptionsIncluded){
                                $("button.vjs-playback-rate.vjs-hidden").removeClass("vjs-hidden");
                                $("button.vjs-audio-button.vjs-hidden").removeClass("vjs-hidden");
                                $("button.vjs-settings-button:not(.vjs-hidden)").addClass("vjs-hidden");
                            }else{
                                $("button.vjs-playback-rate:not(.vjs-hidden)").addClass("vjs-hidden");
                                $("button.vjs-audio-button:not(.vjs-hidden)").addClass("vjs-hidden");
                                $("button.vjs-settings-button.vjs-hidden").removeClass("vjs-hidden");
                            }
                            $scope.updateTimeout = $timeout($scope.makeUpdate, 30);
                        };
                        $scope.updateAudioTrackIcon = function () {
                            //console.log("updateAudioTrackIcon()");
                            //Prevent this code if currently sorting audioTracks
                            if (!$scope.metadataloaded) {
                                return;
                            }
                            //
                            var playerAudioTracks = player.audioTracks();
                            if (playerAudioTracks !== null && playerAudioTracks.length > 0) {
                                //console.log("playerAudioTracks.length: "+playerAudioTracks.length);
                                var audioTrackList = null;
                                if (player.tech_.featuresNativeAudioTracks) {
                                    //console.log("Using Native audioTracks");
                                    var video = $(".video-js-custom.video-js video.vjs-tech")[0];
                                    audioTrackList = video.audioTracks;
                                }
                                //search for main track
                                var mainId = "";
                                for (var i = 0; i < playerAudioTracks.length; i++) {
                                    if ("main" === playerAudioTracks[i].kind) {
                                        mainId = playerAudioTracks[i].id;
                                    }
                                }

                                if (!mainId) {
                                    if (audioTrackList !== undefined && audioTrackList !== null && audioTrackList.length > 0) {
                                        mainId = audioTrackList[0].id;
                                    } else {
                                        mainId = playerAudioTracks[0].id;
                                    }
                                }
                                //console.log("mainId: "+mainId);
                                //Search for enabledId emulated tracks
                                var enabledId = "";
                                for (var i = 0; i < playerAudioTracks.length; i++) {
                                    if (playerAudioTracks[i].enabled) {
                                        enabledId = playerAudioTracks[i].id;
                                    }
                                }

                                //If no track is enabled then enable the main track
                                if (!enabledId) {
                                    enabledId = mainId;
                                    playerAudioTracks.getTrackById(enabledId).enabled = true;
                                }
                                //console.log("enabledId: "+enabledId);
                                // Make json copy of tracks
                                var jsonAudioTracks = [];
                                for (var i = 0; i < playerAudioTracks.length; i++) {
                                    var jsonAudioTrack = {id: playerAudioTracks[i].id, kind: playerAudioTracks[i].kind, label: playerAudioTracks[i].label, language: playerAudioTracks[i].language, enabled: enabledId === playerAudioTracks[i].id};
                                    jsonAudioTracks.push(jsonAudioTrack);
                                }


                                //Set main track kind to main and look for other audio in same language and set kind to main-desc for sorting
                                var mainLabel = jsonAudioTracks.find(item => item.id === mainId).label.toLowerCase();
                                for (var i = 0; i < playerAudioTracks.length; i++) {
                                    if (playerAudioTracks[i].id === mainId) {
                                        jsonAudioTracks.find(item => item.id === playerAudioTracks[i].id).kind = "main";
                                    } else if (playerAudioTracks[i].label.toLowerCase().includes(mainLabel)) {
                                        jsonAudioTracks.find(item => item.id === playerAudioTracks[i].id).kind = "main-desc";
                                    }
                                }

                                //console.log("jsonAudioTracks:\n"+JSON.stringify(jsonAudioTracks, null, 2));
                                // Make sorted json copy of tracks
                                var sortedJsonAudioTracks = null;
                                if (typeof structuredClone === 'function') {
                                    sortedJsonAudioTracks = structuredClone(jsonAudioTracks);
                                } else {
                                    sortedJsonAudioTracks = JSON.parse(JSON.stringify(jsonAudioTracks));
                                }
                                sortedJsonAudioTracks.sort((a, b) => {
                                    var kindComparison = a.kind.localeCompare(b.kind);
                                    if (kindComparison !== 0) {
                                        if (a.kind === "main") {
                                            return -1;
                                        }
                                        if (b.kind === "main") {
                                            return 1;
                                        }
                                        if (a.kind === "main-desc") {
                                            return -1;
                                        }
                                        if (b.kind === "main-desc") {
                                            return 1;
                                        }
                                    }
                                    return a.label.localeCompare(b.label);
                                });
                                //console.log("sortedJsonAudioTracks:\n"+JSON.stringify(sortedJsonAudioTracks, null, 2));
                                // if json copy and sorted json copy are not the same then replace tracks with sorted
                                if (JSON.stringify(jsonAudioTracks) !== JSON.stringify(sortedJsonAudioTracks)) {
                                    //console.log("start sorting");
                                    //console.log("jsonAudioTracks:\n"+JSON.stringify(jsonAudioTracks, null, 2));
                                    //console.log("sortedJsonAudioTracks:\n"+JSON.stringify(sortedJsonAudioTracks, null, 2));
                                    sortedJsonAudioTracks.forEach(track => {
                                        var tempTrack = playerAudioTracks.getTrackById(track.id);
                                        player.audioTracks().removeTrack(tempTrack);
                                        player.audioTracks().addTrack(tempTrack);
                                        //console.log("move "+ track.label);
                                    });
                                    //console.log("stop sorting");
                                }
                                // Update each playerAudioTrack.label and find label for class tag
                                var enabledLabel = "";
                                var hasAudioDescription = false;
                                for (var i = 0; i < playerAudioTracks.length; i++) {
                                    var track = playerAudioTracks[i];
                                    //console.log("Track["+i+"]- id:"+track.id+", kind:"+track.kind+", label:"+track.label+", language:"+track.language+", enabled:"+track.enabled);
                                    if(!player.tech_.featuresNativeAudioTracks){
                                        playerAudioTracks[i].label = playerAudioTracks[i].label.replace("(Audio Description)","[AD]");
                                    }
                                    var label = playerAudioTracks[i].label.split(" ")[0].toLowerCase();
                                    $(".video-js-custom.video-js .vjs-audio-button button").removeClass("vjs-audio-" + label);
                                    $(".video-js-custom.video-js .vjs-menu-audio").removeClass("vjs-audio-" + label);
                                    if (playerAudioTracks[i].enabled) {
                                        enabledLabel = label;
                                        $(".video-js-custom.video-js .vjs-menu-audio .vjs-menu-value").text(playerAudioTracks[i].label);
                                        if(playerAudioTracks[i].label.includes("[AD]")){
                                            $scope.currentAudioDescription = playerAudioTracks[i].label;
                                            $scope.currentAudioDescriptionType = "audio";
                                            $(".video-js-custom.video-js").addClass("vjs-showing-audio-descriptions");
                                        }else{
                                            $scope.currentAudioTrack = playerAudioTracks[i].label;
                                            $(".video-js-custom.video-js").removeClass("vjs-showing-audio-descriptions");
                                        }
                                        $scope.setAudioDescriptionPressed();
                                    }
                                    if(playerAudioTracks[i].label.includes("(Audio Description)") || playerAudioTracks[i].label.includes("[AD]")){
                                        hasAudioDescription = true;
                                    }
                                }
                                if (hasAudioDescription){
                                    $(".video-js-custom.video-js:not(.vjs-has-audio-descriptions)").addClass("vjs-has-audio-descriptions");
                                    $scope.audioDescriptionsIncluded = true;
                                } else {
                                    $(".video-js-custom.video-js.vjs-has-audio-descriptions").removeClass("vjs-has-audio-descriptions");
                                    $scope.audioDescriptionsIncluded = false;
                                }
                                //console.log("enabledLabel: "+enabledLabel);
                                if(enabledLabel){
                                    $(".video-js-custom.video-js .vjs-audio-button button").addClass("vjs-audio-" + enabledLabel);
                                    $(".video-js-custom.video-js .vjs-menu-audio").addClass("vjs-audio-" + enabledLabel);
                                }
                                /*
                                $(".vjs-menu .vjs-menu-item").off("keydown.quizzing");
                                //Catch menu keydown and set focus

                                $(".vjs-menu .vjs-menu-item").on("keydown.quizzing", function (event) {
                                    if (27 === event.which) {
                                        $(".vjs-menu.vjs-lock-showing").parent().children("button:visible").focus();
                                    }
                                });
                                */
                                $(".video-js-custom.video-js .vjs-audio-button .vjs-menu")
                                        .attr("id", "vjs-audio-menu-id")
                                        .attr("aria-labelledby", "vjs-audio-button-id");
                                $(".vjs-audio-button .vjs-menu-item:not(.vjs-has-listener)")
                                    .addClass("vjs-has-listener")
                                    .click(function(event){
                                        $timeout(function(){
                                            //console.log("audio mousedown!");
                                            $("#vjs-audio-button-id").attr("aria-expanded","false");
                                            $("#vjs-settings-audio-button-id").attr("aria-expanded","false");
                                            if($('button.vjs-audio-button').hasClass("vjs-hidden")){
                                                $scope.openSettingsDialog();
                                                $("#vjs-settings-dialog-id button.vjs-menu-audio").focus();
                                            }else{
                                                $('button.vjs-audio-button').focus();
                                            }
                                        });
                                }).on("keydown",function(event){
                                    console.log("keydown which: "+event.which);
                                    if(13===event.which || 32===event.which){
                                        $("#vjs-audio-button-id").attr("aria-expanded","false");
                                        $("#vjs-settings-audio-button-id").attr("aria-expanded","false");
                                        if($('button.vjs-audio-button').hasClass("vjs-hidden")){
                                            $scope.openSettingsDialog();
                                            $("#vjs-settings-dialog-id button.vjs-menu-audio").focus();
                                        }else{
                                            $('button.vjs-audio-button').focus();
                                        }
                                    }
                                });
                            }
                        };
                        $scope.setAudioDescriptionPressed = function(){
                            if($(".video-js-custom.video-js").hasClass("vjs-showing-audio-descriptions") || $(".video-js-custom.video-js").hasClass("vjs-showing-text-audio-descriptions")){
                                $('.video-js-custom.video-js .vjs-audio-descriptions-button-toggle[aria-pressed="false"]').attr("aria-pressed","true");
                            }else{
                                $('.video-js-custom.video-js .vjs-audio-descriptions-button-toggle[aria-pressed="true"]').attr("aria-pressed","false");
                            }
                        };

                        $scope.updateTextTrackDisplay = function () {
                            if (player && player.textTrackDisplay) {
                                $timeout(function () {
                                    player.textTrackDisplay.updateDisplay();
                                });
                            }
                        };

                        /* set and get currentTime rounded*/
                        function playerCurrentTime(time) {
                            if (typeof time !== "undefined") {
                                //console.log("playerCurrentTime("+time+")");
                                player.currentTime(roundValue(time));
                            } else {
                                //console.log("playerCurrentTime(): "+player.currentTime());
                                return roundValue(player.currentTime());
                            }
                        }

                        $scope.convertSRTtoVTT = function (srt) {
                            return 'WEBVTT\n\n' + srt
                                    .replace(/\r+/g, '')
                                    .replace(/(\d+)\n(\d{2}:\d{2}:\d{2}),(\d{3}) --> (\d{2}:\d{2}:\d{2}),(\d{3})/g,
                                            '$1\n$2.$3 --> $4.$5')
                                    .replace(/\n\n\n+/g, '\n\n');
                        };

                        $scope.showTooltip = function (e) {
                            $(".vjs-button").removeClass("vjs-tooltip-show");
                            if ($(e.target).is(".vjs-volume-control")) {
                                $(e.target).addClass("vjs-tooltip-show");
                            } else if ($(e.target).is(".vjs-volume-bar")) {
                                $(e.target).parents(".vjs-volume-control:first").addClass("vjs-tooltip-show");
                            } else if ($(e.target).is(".vjs-button")) {
                                $(e.target).addClass("vjs-tooltip-show");
                            } else {
                                $(e.target).parents(".vjs-button:first").addClass("vjs-tooltip-show");
                            }
                        };
                        $scope.hideTooltip = function (e) {
                            if ($(e.target).is(".vjs-volume-control")) {
                                $(e.target).removeClass("vjs-tooltip-show");
                            } else if ($(e.target).is(".vjs-volume-bar")) {
                                $(e.target).parents(".vjs-volume-control:first").removeClass("vjs-tooltip-show");
                            } else if ($(e.target).is(".vjs-button")) {
                                $(e.target).removeClass("vjs-tooltip-show");
                            } else {
                                $(e.target).parents(".vjs-button:first").removeClass("vjs-tooltip-show");
                            }
                        };
                        $scope.toggleCC = function(){
                            if($scope.captionsIncluded){
                                var isShowing = false;
                                var textTrackList = player.textTracks();
                                for (var i = 0; i < textTrackList.length; i++) {
                                    var track = textTrackList[i];
                                    //console.log("textTrack: "+track.label +"|"+track.kind+"|"+track.mode);
                                    if (track.mode === 'showing' && !track.label.includes("[AD]")) {
                                        isShowing = true;
                                        break;
                                    }
                                }
                                if(isShowing){
                                    for (var i = 0; i < textTrackList.length; i++) {
                                        var track = textTrackList[i];
                                        track.mode = 'disabled';
                                    }
                                    $(".video-js-custom.video-js .vjs-subs-caps-button-toggle").attr("aria-pressed","false");
                                } else {
                                    var useDefault = true;
                                    if($scope.currentTextTrack){
                                        for (var i = 0; i < textTrackList.length; i++) {
                                            var track = textTrackList[i];
                                            if($scope.currentTextTrack===track.label){
                                                track.mode = 'showing';
                                                useDefault = false;
                                            }else{
                                                track.mode = 'disabled';
                                            }
                                        }
                                    }
                                    if(useDefault){
                                        var lookingForCaptions = true;
                                        for (var i = 0; i < textTrackList.length; i++) {
                                            var track = textTrackList[i];
                                            if(lookingForCaptions && track.kind==="captions"){
                                                track.mode = 'showing';
                                                $scope.currentTextTrack = track.label;
                                                lookingForCaptions = false;
                                            }else{
                                                track.mode = 'disabled';
                                            }
                                        }
                                    }
                                    $(".video-js-custom.video-js .vjs-subs-caps-button-toggle").attr("aria-pressed","true");
                                }

                            }
                        };
                        $scope.toggleAudioDescriptions = function(){
                            //console.log("currentAudioDescription: "+ $scope.currentAudioDescriptionType +"|"+$scope.currentAudioDescription);
                            var playerAudioTracks = player.audioTracks();
                            var textTrackList = player.textTracks();
                            if($(".video-js-custom.video-js").hasClass("vjs-showing-audio-descriptions") || $(".video-js-custom.video-js").hasClass("vjs-showing-text-audio-descriptions")){
                                if($(".video-js-custom.video-js").hasClass("vjs-showing-audio-descriptions")){
                                    var useDefault = true;
                                    for (var i = 0; i < playerAudioTracks.length; i++) {
                                        var track = playerAudioTracks[i];
                                        if($scope.currentAudioTrack===track.label){
                                            track.enabled = true;
                                            useDefault = false;
                                        }
                                    }
                                    if(useDefault){
                                        playerAudioTracks[0].enabled = true;
                                        $scope.currentAudioTrack===playerAudioTracks[0].label;
                                    }
                                }
                                if($(".video-js-custom.video-js").hasClass("vjs-showing-text-audio-descriptions")){
                                    var useDefault = true;
                                    for (var i = 0; i < textTrackList.length; i++) {
                                        var track = textTrackList[i];
                                        track.mode = 'disabled';
                                    }
                                }
                            }else{
                                var useDefault = true;
                                if($scope.currentAudioDescriptionType==="audio" && $scope.currentAudioDescription){
                                    if (playerAudioTracks !== null && playerAudioTracks.length > 0) {
                                        for (var i = 0; i < playerAudioTracks.length; i++) {
                                            var track = playerAudioTracks[i];
                                            if($scope.currentAudioDescription===track.label){
                                                track.enabled = true;
                                                useDefault = false;
                                            }
                                        }
                                    }
                                }
                                if(useDefault && $scope.currentAudioDescriptionType==="text" && $scope.currentAudioDescription){
                                    if(useDefault && textTrackList && textTrackList.length > 0){
                                        var useDefault = true;
                                        for (var i = 0; i < textTrackList.length; i++) {
                                            var track = textTrackList[i];
                                            if($scope.currentAudioDescription===track.label){
                                                track.mode = 'showing';
                                                useDefault = false;
                                            }else{
                                                track.mode = 'disabled';
                                            }
                                        }
                                    }
                                }
                                if(useDefault && textTrackList && textTrackList.length > 0){
                                    for (var i = 0; i < playerAudioTracks.length; i++) {
                                        var track = playerAudioTracks[i];
                                        //console.log("audio-track: "+track.id+"|"+track.kind+"|"+track.label+"|"+track.language+"|"+track.enabled+"|"+track.label.includes("[AD]"));
                                        if (track.label.includes("[AD]")) {
                                            track.enabled = true;
                                            $scope.currentAudioDescriptionType="audio";
                                            $scope.currentAudioDescription = track.label;
                                            useDefault = false;
                                            break;
                                        }
                                    }
                                }
                                if(useDefault && textTrackList && textTrackList.length > 0){
                                    var trackNotFound = true;
                                    for (var i = 0; i < textTrackList.length; i++) {
                                        var track = textTrackList[i];
                                        if(trackNotFound && track.label.includes("[AD]")){
                                            track.mode = 'showing';
                                            $scope.currentAudioDescriptionType="text";
                                            $scope.currentAudioDescription = track.label;
                                            trackNotFound = false;
                                            break;
                                        }else{
                                            track.mode = 'disabled';
                                        }
                                    }
                                }
                            }
                        };
                        $scope.toggleSettingsDialog = function(){
                            var settingsDialog = $("#vjs-settings-dialog-id");
                            if(settingsDialog.hasClass("vjs-lock-showing")){
                                settingsDialog.removeClass("vjs-lock-showing");
                                settingsDialog.parent().find('[tabindex="0"]').first().focus();
                                $("#vjs-settings-button-id").attr("aria-expanded","false");
                            }else{
                                settingsDialog.addClass("vjs-lock-showing");
                                $("#vjs-settings-button-id").attr("aria-expanded","true");
                                $timeout(function(){
                                    settingsDialog.find('[tabindex="0"]').first().focus();
                                });
                            }
                        };
                        $scope.openSettingsDialog = function(){
                            //console.log("openSettingsDialog()");
                            $("#vjs-settings-dialog-id:not(.vjs-lock-showing)").addClass("vjs-lock-showing");
                            $("#vjs-settings-button-id").attr("aria-expanded","true");
                        };
                        $scope.closeSettingsDialog = function(){
                            //console.log("closeSettingsDialog()");
                            $("#vjs-settings-dialog-id.vjs-lock-showing").removeClass("vjs-lock-showing");
                            $("#vjs-settings-button-id").attr("aria-expanded","false");
                        };
                        $scope.toggleADDialog = function() {
                            $timeout(function(){
                                $("button.vjs-descriptions-button").click();
                            },10);
                        };
                        $scope.toggleCCDialog = function() {
                            $timeout(function(){
                                $("button.vjs-subs-caps-button").click();
                            },10);
                        };
                        $scope.toggleAudioDialog = function() {
                            $timeout(function(){
                                $("button.vjs-audio-button").click();
                                if($("#vjs-audio-menu-id").is(":visible")){
                                    $("#vjs-audio-menu-id").attr("aria-expanded","true");
                                }else{
                                    $("#vjs-audio-menu-id").attr("aria-expanded","false");
                                }
                            },10);
                        };
                        $scope.toggleSpeedDialog = function() {
                            $timeout(function(){
                                $("button.vjs-playback-rate").click();
                            },10);
                        };
                        $scope.hideSettingsDialogWhenClickOutside = function(e){
                            if($(e.target).parents(".vjs-settings").length ===0){
                                $("#vjs-settings-dialog-id.vjs-lock-showing").removeClass("vjs-lock-showing");
                                $("#vjs-settings-button-id").attr("aria-expanded","false");
                            }
                        };
                        $scope.toggleMoreActionsDialog = function(){
                            //console.log("toggleSettingsDialog()");
                            var moreActionsDialog = $("#vjs-more-actions-dialog-id");
                            if(moreActionsDialog.hasClass("vjs-lock-showing")){
                                moreActionsDialog.removeClass("vjs-lock-showing");
                                $("#vjs-more-actions-button-id").attr("aria-expanded","false");
                                moreActionsDialog.parent().find('[tabindex="0"]').first().focus();
                            }else{
                                moreActionsDialog.addClass("vjs-lock-showing");
                                $("#vjs-more-actions-button-id").attr("aria-expanded","true");
                                $timeout(function(){
                                    moreActionsDialog.find('[tabindex="0"]').first().focus();
                                });
                            }
                        };
                        $scope.openMoreActionsDialog = function(){
                            //console.log("openSettingsDialog()");
                            $("#vjs-more-actions-dialog-id:not(.vjs-lock-showing)").addClass("vjs-lock-showing");
                            $("#vjs-more-actions-button-id").attr("aria-expanded","true");
                        };
                        $scope.closeMoreActionsDialog = function(){
                            //console.log("closeSettingsDialog()");
                            $("#vjs-more-actions-dialog-id.vjs-lock-showing").removeClass("vjs-lock-showing");
                            $("#vjs-more-actions-button-id").attr("aria-expanded","false");
                        };
                        $scope.hideMoreActionsDialogWhenClickOutside = function(e){
                            if($(e.target).parents(".vjs-more-actions").length ===0){
                                $("#vjs-more-actions-dialog-id.vjs-lock-showing").removeClass("vjs-lock-showing");
                                $("#vjs-more-actions-button-id").attr("aria-expanded","false");
                            }
                        };
                        $scope.menuDialogWhenClickOutside = function(e){
                            if($(".vjs-menu.vjs-lock-showing").length > 0){
                                var menuId = $(".vjs-menu.vjs-lock-showing").attr("id");
                                var menuButtonId = $(".vjs-menu.vjs-lock-showing").attr("aria-labelledby");
                                if($(e.target).closest("#"+menuId).length ===0 &&
                                    $(e.target).closest("#"+menuButtonId).length ===0){
                                    $("#"+menuId).removeClass("vjs-lock-showing");
                                    $("#"+menuButtonId).attr("aria-expanded","false");
                                }
                            }
                        };
                        $scope.getLangCode = function(lang){
                            var langData = [{lang: "Afrikaans", code: "af"},{lang: "Amharic", code: "am"},{lang: "Arabic", code: "ar"},{lang: "Assamese", code: "as"},
                                {lang: "Azerbaijani", code: "az"},{lang: "Bashkir", code: "ba"},{lang: "Bulgarian", code: "bg"},{lang: "Bengali", code: "bn"},
                                {lang: "Tibetan", code: "bo"},{lang: "Breton", code: "br"},{lang: "Catalan", code: "ca"},{lang: "Corsican", code: "co"},
                                {lang: "Czech", code: "cs"},{lang: "Welsh", code: "cy"},{lang: "Danish", code: "da"},{lang: "German", code: "de"},
                                {lang: "Greek", code: "el"},{lang: "English", code: "en"},{lang: "Spanish", code: "es"},{lang: "Estonian", code: "et"},
                                {lang: "Basque", code: "eu"},{lang: "Persian", code: "fa"},{lang: "Finnish", code: "fi"},{lang: "Faroese", code: "fo"},
                                {lang: "French", code: "fr"},{lang: "Frisian", code: "fy"},{lang: "Irish", code: "ga"},{lang: "Galician", code: "gl"},
                                {lang: "Gujarati", code: "gu"},{lang: "Hausa", code: "ha"},{lang: "Hebrew", code: "he"},{lang: "Hindi", code: "hi"},
                                {lang: "Croatian", code: "hr"},{lang: "Hungarian", code: "hu"},{lang: "Armenian", code: "hy"},{lang: "Indonesian", code: "id"},
                                {lang: "Icelandic", code: "is"},{lang: "Italian", code: "it"},{lang: "Inuktitut", code: "iu"},{lang: "Japanese", code: "ja"},
                                {lang: "Georgian", code: "ka"},{lang: "Kazakh", code: "kk"},{lang: "Greenlandic", code: "kl"},{lang: "Kannada", code: "kn"},
                                {lang: "Korean", code: "ko"},{lang: "Kurdish", code: "ku"},{lang: "Lithuanian", code: "lt"},{lang: "Macedonian", code: "mk"},
                                {lang: "Malayalam", code: "ml"},{lang: "Mongolian", code: "mn"},{lang: "Marathi", code: "mr"},{lang: "Malay", code: "ms"},
                                {lang: "Maltese", code: "mt"},{lang: "Burmese", code: "my"},{lang: "Nepali", code: "ne"},{lang: "Dutch", code: "nl"},
                                {lang: "Norwegian", code: "no"},{lang: "Occitan", code: "oc"},{lang: "Punjabi", code: "pa"},{lang: "Polish", code: "pl"},
                                {lang: "Portuguese", code: "pt"},{lang: "Quechua", code: "qu"},{lang: "Romanian", code: "ro"},{lang: "Russian", code: "ru"},
                                {lang: "Kinyarwanda", code: "rw"},{lang: "Sanskrit", code: "sa"},{lang: "Sindhi", code: "sd"},{lang: "Slovak", code: "sk"},
                                {lang: "Slovenian", code: "sl"},{lang: "Albanian", code: "sq"},{lang: "Serbian", code: "sr"},{lang: "Sesotho", code: "st"},
                                {lang: "Swedish", code: "sv"},{lang: "Tamil", code: "ta"},{lang: "Telugu", code: "te"},{lang: "Tajik", code: "tg"},
                                {lang: "Thai", code: "th"},{lang: "Turkmen", code: "tk"},{lang: "Tagalog", code: "tl"},{lang: "Turkish", code: "tr"},
                                {lang: "Tatar", code: "tt"},{lang: "Ukrainian", code: "uk"},{lang: "Urdu", code: "ur"},{lang: "Uzbek", code: "uz"},
                                {lang: "Vietnamese", code: "vi"},{lang: "Wolof", code: "wo"},{lang: "Xhosa", code: "xh"},{lang: "Yiddish", code: "yi"},
                                {lang: "Yoruba", code: "yo"},{lang: "Chinese", code: "zh"},{lang: "Zulu", code: "zu"}];

                            var langCode = langData.find(u => u.lang.toUpperCase() === lang.toUpperCase()).code;
                            if(langCode){
                                return langCode;
                            }else{
                                return lang;
                            }
                        };
                        $(window).on("click.ssplayervsjdirective", function (e) {
                            $scope.hideSettingsDialogWhenClickOutside(e);
                            $scope.hideMoreActionsDialogWhenClickOutside(e);
                        });
                        $(window).on("pointerdown.ssplayervsjdirective", function (e) {
                            $scope.menuDialogWhenClickOutside(e);
                        });
                        $(document).on("keydown.ssplayervsjdirective", function (event) {
                            if (event.which === 27) {
                                if ($(".fp-menu.fp-subtitle-menu").is(".fp-active")) {
                                    $('.fp-subtitle-menu .fp-selected').get(0).click();
                                } else if ($(".fp-menu.fp-speed-menu").is(".fp-active")) {
                                    $('.fp-speed-menu .fp-selected').get(0).click();
                                } else if ($(".fp-menu.fp-audio-menu").is(".fp-active")) {
                                    $('.fp-audio-menu .fp-selected').get(0).click();
                                }
                                if($("#vjs-settings-dialog-id").hasClass("vjs-lock-showing")){
                                    $("#vjs-settings-dialog-id").removeClass("vjs-lock-showing");
                                    $(".vjs-settings-button").focus();
                                    $("#vjs-settings-button-id").attr("aria-expanded","false");
                                }
                                $('#vjs-settings-dialog-id button[aria-expanded="true"]').attr("aria-expanded","false");
                                $(".vjs-button").removeClass("vjs-tooltip-show");
                                if($("#vjs-more-actions-dialog-id").hasClass("vjs-lock-showing")){
                                    $("#vjs-more-actions-button-id").focus();
                                    $scope.closeMoreActionsDialog();
                                }
                            }
                        });
                        window.addEventListener('pagehide', windowUnload, false);
                        function windowUnload(event) {
                            // The page is unloading or entering the back/forward cache. An XHR
                            // fired here gets killed by the browser (Safari logs it as an
                            // access-control failure), so report the drop-off with a beacon,
                            // which is guaranteed to survive page teardown.
                            if (!player.paused()) {
                                navigator.sendBeacon('api/asset/media/record', new Blob([JSON.stringify({
                                    cid: $scope.asset.cid,
                                    aid: $scope.asset.aid,
                                    type: 'S',
                                    sessionId: sessionId,
                                    secondsPlayed: player.currentTime(),
                                    mediaDuration: player.duration()
                                })], {type: 'application/json'}));
                                mediaDropOff.hasFinished = true;
                            }
                        };
                        $scope.$on('$destroy', function () {
                            console.log('ssplayervjs.directive.js controller is being destroyed, performing cleanup...');
                            $scope.resizeObserver.unobserve($scope.playerEl);
                            $timeout.cancel($scope.updateTimeout);
                            $(document).off("keydown.ssplayervsjdirective");
                            $(window).off("click.ssplayervsjdirective");
                            $(window).off("pointerdown.ssplayervsjdirective");
                            window.removeEventListener('pagehide', windowUnload);
                            //$(window).off('beforeunload.ssplayervsjdirective');
                            $(".vjs-menu .vjs-menu-item").off("keydown.ssplayervsjdirective");
                        });
                    }
                };
            }]);
